Ext.namespace('Ext.ux.wx');
// Utiliser par Ext.encode dans WebSocketProxy
Ext.JSON.encodeDate = function (d) {
  return Ext.Date.format(d, '"' + Ext.util.Format.internalJSONDateTime + '"');
}; // Ext.encode replaces special characters by unicode tag (é -> \u0009), not yet supported by ExtPascal


Ext.JSON.encodeString = function (s) {
  return JSON.stringify(s);
};

Ext.applyIf(RegExp, {
  escape: function escape(str) {
    return str.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
  }
}); // Fonction utilisée aussi bien pour les dates que pour les heures

Ext.isDateTime = function (obj) {
  // D'après Ext.data.Model.isEqual, instanceof est ~10 fois plus rapide que Ext.isDate
  return obj instanceof Date; //return Ext.isDate(obj);
};

Ext.ux.wx.Utils = {
  /* Encode value as websocket message param */
  encodeParamValue: function encodeParamValue(value) {
    // Escape '&' character with SUBstitute code
    if (typeof value == 'string') {
      // ordre important
      return value.replace(/%/g, '%25').replace(/&/g, '%26').replace(/=/g, '%3D');
    } else {
      return value;
    }
  },

  /* Return the normalized value */
  normalizeValue: function normalizeValue(value) {
    // Pour les grid value est un string au format JSON (cf. WebSocketProxy)
    // Une des valeurs du Json peut contenir null, ceci étant géré par DataController sur le server
    if (value === undefined || value === null) {
      return '';
    } else {
      // Escape '&' character with SUBstitute code
      return Ext.ux.wx.Utils.encodeParamValue(value);
    }
  },
  getCompNormalizeValue: function getCompNormalizeValue(comp, value, context) {
    var normalizedValue, valid;
    if (comp.beforeNormalizedValue) comp.beforeNormalizedValue();

    if (comp.getNormalizedValue) {
      // Appeler normalizeValue au lieu de encodeParamValue si besoin
      normalizedValue = Ext.ux.wx.Utils.encodeParamValue(comp.getNormalizedValue(value, context));
    } else {
      normalizedValue = Ext.ux.wx.Utils.normalizeValue(value);
    }

    if (value !== undefined && value !== null && comp.isValidateValue) {
      //La validation est faite sur la valeur non normalisée
      //La valeur normalisée est la valeur renvoyée au serveur
      valid = comp.isValidateValue(value, context);
    } else {
      valid = true;
    }

    return {
      'value': normalizedValue,
      'valid': valid
    };
  },
  applyConfigValue: function applyConfigValue(component, config, value) {
    var capitalizedName = config.charAt(0).toUpperCase() + config.substr(1);
    if (component['set' + capitalizedName]) component['set' + capitalizedName](value);else component[config] = value;
  },
  getConfigValue: function getConfigValue(component, config) {
    var capitalizedName = config.charAt(0).toUpperCase() + config.substr(1);
    if (component['get' + capitalizedName]) return component['get' + capitalizedName]();else return component[config];
  }
};
/*EXTJS6*/
// N'existe plus en ExtJS 6 !

/* jshint ignore:start */

function wxAddEvents() {// Nothing todo only for documentation purpose
}
/* jshint ignore:end */
/**
 * @class Ext.ux.wx.LockMaskManager
 * @singleton
 */
Ext.define('Ext.ux.wx.LockMaskManager', {
  singleton: true,
  // private
  registerList: [],
  lockMaskState: 0,
  DELAY_STANDARD: 500,
  DELAY_SHORT: 100,
  DELAY_NONE: 0,
  getActiveLockableWindow: function getActiveLockableWindow() {
    var stack = Ext.WindowMgr.zIndexStack || [],
        i = stack.indexOf(Ext.WindowMgr.getActive()),
        item;

    for (; i > -1; i--) {
      item = stack.getAt(i);
      if (item && item.useLockMask) return item;
    }
  },
  createLockMask: function createLockMask(win) {
    if (!win.lockMaskCmp) win.lockMaskCmp = {
      lockMask: this.newLockMask(win),
      delay: new Ext.util.DelayedTask(),
      state: 0,
      // Il y a un state individuel <> du state global car LockMaskMixin ne lock que la form active (problème des modale)
      delayedShow: function delayedShow() {
        var me = this;
        if (me.lockMask && !me.lockMask.destroyed) me.lockMask.show();
      },
      show: function show(delay) {
        var me = this; // Si aucun mask n'est affiché, l'afficher avec delay

        if (!me.state) //me.lockMask.show();
          me.delay.delay(delay || Ext.ux.wx.LockMaskManager.DELAY_STANDARD, me.delayedShow, me);
        ++me.state;
      },
      hide: function hide(reset) {
        var me = this;
        if (reset) me.state = 0;else --me.state; // Si plus locké, on peut cacher le masque

        if (!me.state) {
          me.delay.cancel();
          me.lockMask.hide();
        }
      },
      destroy: function destroy() {
        var me = this;

        if (me.delay) {
          me.delay.cancel();
          me.delay = null;
        }

        if (me.lockMask) me.lockMask.destroy();
      },
      isLocked: function isLocked() {
        return !!this.state;
      }
    };
  },
  // private
  newLockMask: function newLockMask(win) {
    return new Ext.LoadMask({
      target: win,
      msg: Ext.ux.wx.TranslateManager.getWord('txtAppLockMask', 'Please wait...')
    });
  },

  /**
   * Show mask
   */
  showLockMask: function showLockMask() {
    var me = this,
        i;

    if (!me.lockMaskState) {
      for (i = 0; i < me.registerList.length; i++) me.showLockMaskContainer(me.registerList[i]);
    }

    ++me.lockMaskState;
  },
  // called by mixin
  showLockMaskContainer: function showLockMaskContainer(cont, delay) {
    if (cont && !cont.hidden) {
      this.createLockMask(cont); // Il y a un lock individuel <> du lock global car LockMaskMixin ne lock que la form active (problème des modale)
      // Si aucun mask n'est affiché, l'afficher

      cont.lockMaskCmp.show(delay);
    }
  },

  /**
   * Hide mask
   */
  hideLockMask: function hideLockMask() {
    var me = this,
        i; // Si pas de lock, on fait rien (show a pu être perdu / Ex: Contrôle d'accès - PC_CTRL_ACC)

    if (!me.lockMaskState) return;
    --me.lockMaskState;

    if (!me.lockMaskState) {
      for (i = 0; i < me.registerList.length; i++) {
        me.hideLockMaskContainer(me.registerList[i]);
      }
    }
  },
  hideLockMaskContainer: function hideLockMaskContainer(cont, reset) {
    if (cont && (!cont.hidden || reset) && cont.lockMaskCmp) {
      cont.lockMaskCmp.hide(reset);
    }
  },
  destroyLockMaskContainer: function destroyLockMaskContainer(cont) {
    if (cont && cont.lockMaskCmp) {
      cont.lockMaskCmp.destroy();
      delete cont.lockMaskCmp;
      delete cont.useLockMask;
    }
  },
  hasLockMaskContainer: function hasLockMaskContainer(cont) {
    if (cont && !cont.hidden && cont.lockMaskCmp) {
      return cont.lockMaskCmp.isLocked();
    }

    return false;
  },
  isLockedMask: function isLockedMask(cmp) {
    if (cmp.isLockedMask) return cmp.isLockedMask(true);else return this.hasLockMaskContainer(this.getActiveLockableWindow());
  },
  // private
  register: function register(win) {
    var me = this;
    Ext.Array.push(me.registerList, win);
    win.on({
      show: me.onShowRegister,
      hide: me.onHideRegister,
      scope: me
    });
    win.useLockMask = true;
    if (me.lockMaskState) me.showLockMaskContainer(win);
  },
  // private
  unregister: function unregister(win) {
    var me = this;
    Ext.Array.remove(me.registerList, win);
    win.un({
      show: me.onShowRegister,
      hide: me.onHideRegister,
      scope: me
    });

    if (win.lockMaskCmp) {
      win.lockMaskCmp.hide();
      win.lockMaskCmp.destroy();
    }

    delete win.lockMaskCmp;
    delete win.useLockMask;
  },
  onShowRegister: function onShowRegister(win) {
    if (this.lockMaskState) this.showLockMaskContainer(win);
  },
  onHideRegister: function onHideRegister(win) {
    this.hideLockMaskContainer(win, true);
  }
});
/**
 * @class Ext.ux.wx.FocusObserver
 *
 * The FocusObserver is responsible for globally:
 *
 * 1. Observing component focus
 * 2. Providing previous/next component focus change
 * 3. [not implemented](optional) Provide a visual cue for focused components, in the form of a focus ring/frame.
 *
 * FocusObserver is enabled by default and cannot be disabled.
 *
 * @singleton
 * @author JCH
 * @docauthor JCH
 */
Ext.define('Ext.ux.wx.FocusObserver', {
  singleton: true,

  /**
   * @property {Ext.Component} focusedCmp
   * The currently focused component.
   */
  whitelist: ['textfield', 'pickerdate', 'wxpickerdate'],
  constructor: function constructor(config) {
    var me = this,
        CQ = Ext.ComponentQuery; //me.focusTask = new Ext.util.DelayedTask(me.handleComponentFocus, me);
    // Gain control on Component focus, blur, hide and destroy

    Ext.override(Ext.Component, {
      onFocus: function onFocus() {
        this.callParent(arguments);

        if (this.hasFocus) {
          Array.prototype.unshift.call(arguments, this);
          me.onComponentFocus.apply(me, arguments);
        }
      },
      onBlur: function onBlur() {
        this.callParent(arguments);

        if (!this.hasFocus) {
          Array.prototype.unshift.call(arguments, this);
          me.onComponentBlur.apply(me, arguments);
        }
      },
      onDestroy: function onDestroy() {
        this.callParent(arguments);
        Array.prototype.unshift.call(arguments, this);
        me.onComponentDestroy.apply(me, arguments);
      },
      privates: {
        /* revertFocus est utilisé pour placer le focus quand un composant est caché/désactivé. Extjs le place
           sur le composant qui avait le focus juste avant (d'où son nom), mais selon nous il doit aller au
           composant suivant dans l'ordre de tabulation (d'où l'utilisation de selectNext).
           Basé sur Ext.FocusMAnager.onComponentHide d' Extjs 4.x */
        revertFocus: function revertFocus() {
          var cmp = this,
              cmpHadFocus;

          if (!cmp.isWindow) {
            // See if the Component being hidden was the focused Component, or owns the focused Component
            // In these cases, focus needs to be removed from the focused Component to the next focusable component
            cmpHadFocus = cmp.hasFocus || me.focusedCmp && cmp.isContainer && cmp.isAncestor(me.focusedCmp);
          }

          if (!cmpHadFocus || !me.selectNext(cmp)) this.callParent(arguments);
        },
        revertFocusTo: function revertFocusTo(target) {
          var me = this; // Ne pas remettre le focus sur une cellule précédente, mais bien sur la cellule active
          // Problème lors du disable des boutons du Ribbon => RevertFocus => focus sur une ancienne cellule du tree/grid

          if (me.isTableView) me.focus();else me.callParent(arguments);
        }
      } // onDisable: function() {    // Si besoin (cf afterHide)
      //     this.callParent(arguments);
      //     Array.prototype.unshift.call(arguments, this);
      //     me.onComponentDisable.apply(me, arguments);
      // },
      // onRemove: function() {    // Si besoin (cf afterHide)
      //     this.callParent(arguments);
      //     Array.prototype.unshift.call(arguments, this);
      //     me.onComponentRemove.apply(me, arguments);
      // },
      // afterHide: function() {    // Remplacé par revertFocus
      //     this.callParent(arguments);
      //     Array.prototype.unshift.call(arguments, this);
      //     me.onComponentHide.apply(me, arguments);
      // }

    }); // Setup KeyNav that's bound to document to catch all
    // unhandled/bubbled key events for navigation

    me.keyNav = new Ext.util.KeyNav({
      target: Ext.getDoc(),
      scope: me,
      // backspace: me.onBackSpace, le backspace semble être déjà bloqué par autre chose
      left: me.navigateSiblings,
      right: me.navigateSiblings,
      down: me.navigateSiblings,
      up: me.navigateSiblings
    }); // Setup some ComponentQuery pseudos

    Ext.apply(CQ.pseudos, {
      // Return the single next focusable sibling from the current idx in either direction (step -1 or 1)
      nextFocus: function nextFocus(cmps, idx, step) {
        step = step || 1;
        idx = parseInt(idx, 10);
        var len = cmps.length,
            i = idx,
            c;

        for (;;) {
          // Increment index, and loop round if off either end
          if ((i += step) >= len) {
            i = 0;
          } else if (i < 0) {
            i = len - 1;
          } // As soon as we loop back to the starting index, give up, there are no focusable siblings.


          if (i === idx) {
            return [];
          } // If we have found a focusable sibling, return it


          c = cmps[i];

          if (c.isFocusable()) {
            return [c];
          }
        }

        return [];
      },
      prevFocus: function prevFocus(cmps, idx) {
        return this.nextFocus(cmps, idx, -1);
      },
      root: function root(cmps) {
        var len = cmps.length,
            results = [],
            i = 0,
            c;

        for (; i < len; i++) {
          c = cmps[i];

          if (!c.ownerCt) {
            results.push(c);
          }
        }

        return results;
      }
    });
  },
  startDebug: function startDebug(delay) {
    var me = this;

    window.foDebug = function () {
      var cmp = me.focusedCmp,
          form = Ext.WindowManager.lastActiveForm,
          msg;
      msg = 'focusedCmp: ' + (cmp && cmp.$className + '/' + (cmp.nm || cmp.id) + '/' + (cmp.internalName || cmp.text || cmp.value));
      msg += '    -   ';
      cmp = form && form.activeFocus;
      msg += 'activeFocus: ' + (cmp && cmp.$className + '/' + (cmp.nm || cmp.id) + '/' + (cmp.internalName || cmp.text || cmp.value));
      console.warn(msg);
      Ext.defer(window.foDebug, delay || 1000);
    };

    window.foDebug();
  },
  stopDebug: function stopDebug() {
    window.foDebug = function () {};
  },
  // onBackSpace: function(e) {
  //     var me = this;
  //     if (/*ReadOnly fields don't allow backspace*/me.focusedCmp && !me.focusedCmp.readOnly && me.isWhitelisted(me.focusedCmp)) {
  //         return true;
  //     }
  //     // Don't block inputText TODO: voir pour faire mieux !
  //     if (e && e.target && !e.target.readOnly && !e.target.disabled && ((e.target.tagName == 'TEXTAREA') ||
  //                                                                       ((e.target.tagName == 'INPUT') && (-1 == ['radio', 'checkbox', 'submit', 'button', 'image'].indexOf(e.target.type.toLowerCase()))) ||
  //                                                                       ((e.target.tagName == 'DIV') && e.target.contentEditable) ||
  //                                                                       (e.target.classList.contains('x-list-input'))))
  //         return true;
  //     // Blocks sandard backspace action (previous page)
  //     return false;
  // },
  getRootComponents: function getRootComponents() {
    var CQ = Ext.ComponentQuery,
        inline = CQ.query(':focusable:root:not([floating])'),
        floating = CQ.query(':focusable:root[floating]'); // Floating items should go to the top of our root stack, and be ordered
    // by their z-index (highest first)

    floating.sort(function (a, b) {
      return a.el.getZIndex() > b.el.getZIndex();
    });
    return floating.concat(inline);
  },
  isWhitelisted: function isWhitelisted(cmp) {
    return cmp && Ext.Array.some(this.whitelist, function (x) {
      return cmp.isXType(x);
    });
  },
  navigateSiblings: function navigateSiblings(e, source, parent) {
    // On ne peut pas utiliser selectNext car on boucle sur un groupe local de composants, on ne parcours pas tous
    // les composants de la form.
    var me = this,
        src = source || me,
        key = e.getKey(),
        EO = Ext.event.Event,
        goBack = e.shiftKey || key == EO.LEFT || key == EO.UP,
        checkWhitelist = key == EO.LEFT || key == EO.RIGHT || key == EO.UP || key == EO.DOWN,
        nextSelector = goBack ? 'prev' : 'next',
        idx,
        next,
        focusedCmp,
        siblings; // Ne pas bloquer les touches de navigation dans listIconView en mode text

    if (e.target.classList.contains('x-list-input')) return true;
    focusedCmp = src.focusedCmp && src.focusedCmp.comp || src.focusedCmp;

    if (!focusedCmp && !parent) {
      return true;
    }

    if (checkWhitelist && me.isWhitelisted(focusedCmp)) {
      return true;
    } // If no focused Component, or a root level one was focused, then siblings are root components.


    if (!focusedCmp || focusedCmp.is(':root')) {
      siblings = me.getRootComponents();
    } else {
      // Else if the focused component has a parent, get siblings from there
      parent = parent || focusedCmp.up();

      if (parent && !parent.isTabBar && // Le déplacement sur la tabBar est déjà géré par ExtJS (selon activateOnFocus)
      !parent.isMenu) {
        // Le déplacement dans les menus est déjà géré par ExtJS
        siblings = parent.getRefItems();
      }
    } // Navigate if we have found siblings.


    if (siblings) {
      // Tri selon tabIndex, cf override findTabbableElements
      Ext.Array.sort(siblings, function (item1, item2) {
        return (item1.tabIndex === 0 ? 32766 : item1.tabIndex) - (item2.tabIndex === 0 ? 32766 : item2.tabIndex);
      });
      idx = focusedCmp ? Ext.Array.indexOf(siblings, focusedCmp) : -1;
      next = Ext.ComponentQuery.query(':' + nextSelector + 'Focus(' + idx + ')', siblings)[0];

      if (next && focusedCmp !== next) {
        next.focus();
        return next;
      }
    }
  },
  onComponentBlur: function onComponentBlur(cmp, e) {
    var me = this
    /*,
    caretPos*/
    ; // On désélectionne le texte pour corriger un problème de focus lors du clic sur le label d'une checkbox alors
    // que le focus est dans un edit dont le texte est sélectionné (le focus du checkbox n'est jamais déclenché
    // et le code ci-dessous remettait le focus dans l'edit). Firefox, IE et Edge ne posent pas problème.
    // -> Problème corrigé dans Chrome v65
    // if (Ext.isChrome && cmp && cmp.selectText) {
    //     caretPos = cmp.getCaretPos ? cmp.getCaretPos() : 0;
    //     cmp.selectText(caretPos, caretPos);
    // }

    if (me.focusedCmp === cmp) {
      me.previousFocusedCmp = cmp;
      delete me.focusedCmp;
    }
  },
  onComponentFocus: function onComponentFocus(cmp, e) {
    var me = this,
        currCmp,
        prevCmp,
        form;
    /*EXTJS6: Tests à revoir après résolution du focus dans les composant compliqués (gridview avec tabIndex = 0 par
      exemple). Pour l'instant on sauvegarde toujours focusedCmp, mais pour le form.activeFocus (utilisé pour
      replacer le focus après fermeture d'une modale) on ignore les composants du ribbon (en fait que les boutons
      avec le test !inRibbon), à voir s'il faut ignorer tous les composants isFocusable() = false ou avec
      tabIndex = -1.
      La partie du test sur cmp.editor est nécessaire pour le CodeMirrorField (car cmp.getTabIndex()/tabIndex = -1)
      */

    if (!cmp.isWindow && !cmp.isLoadMask && !cmp.isDatePicker) {
      me.focusedCmp = cmp; //if (!cmp.inRibbon) { // Ne suffit pas pour exclure les tabs du ribbon
      //if (!cmp.inRibbon && cmp.isFocusable()) { // Ne suffit pas pour exclure les tabs du ribbon

      if (!cmp.inRibbon && // Exclut les boutons du ribbon
      !(cmp.ownerCt && cmp.ownerCt.inRibbon) && // Exclut les tabs du ribbon
      !cmp.parentMenu && ( // Exclut les items de menu
      // InplaceEdit ou Tabulation
      cmp.inEditor || (cmp.editor && cmp.editor.options && cmp.editor.options.tabindex || cmp.getTabIndex && cmp.getTabIndex() || cmp.tabIndex) > -1)) {
        // if ((cmp.editor && cmp.editor.options && cmp.editor.options.tabindex || cmp.getTabIndex && cmp.getTabIndex() || cmp.tabIndex) < 0) {
        //     console.error('Component shouldn\'t be registered as activeFocus: ' +
        //         (cmp.$className + '/' + (cmp.nm || cmp.id) + '/' + (cmp.internalName || cmp.text || cmp.value)));
        // }
        // console.warn('prevfocusedCmp: ' + (me.previousFocusedCmp && (me.previousFocusedCmp.$className + '/' + (me.previousFocusedCmp.nm || me.previousFocusedCmp.id) + '/' + (me.previousFocusedCmp.internalName || me.previousFocusedCmp.text || me.previousFocusedCmp.value))));
        // console.warn('focusedCmp: ' + (cmp && (cmp.$className + '/' + (cmp.nm || cmp.id) + '/' + (cmp.internalName || cmp.text || cmp.value))));
        // Le faire sans delay sinon le focus risque de ne pas être enregistré
        // form = Ext.WindowManager.getActive();
        form = Ext.WindowManager.lastActiveForm; // on réiniialise le focus sur la form (ex: fermeture d'une modale), pas de changemement => rien à faire

        if (form && form.activeFocus === cmp) return; // on réiniialise le focus sur la form (ex: message d'erreur), pas de changemement => rien à faire

        if (form && form.wxIsMessageBox) //internalClassName === "TbfrmMessageBox")
          return;

        if (form && form.isAncestor(cmp)) {
          form.activeFocus = cmp;
        } // Notification pour appel aux events métier
        // Grid: ne pas appeler les events métier lors de (dès-)activation inplaceEdit)
        // Tous les composants: ne pas appeler les events métier lors de la fermeture d'une modale (ré-init focus)
        // => appeler les events métier uniquement si le composant ayant le focus change
        //
        // Pour les grids, s'il s'agit de l'éditeur, notifier la vue


        currCmp = cmp.inEditor ? cmp.ownerCt.context.view : cmp;
        prevCmp = me.previousFocusedCmp;
        if (prevCmp && prevCmp.inEditor) prevCmp = prevCmp.ownerCt.context.view; // Ne pas notifier si c'est sur le même grid mais pas la même vue (locked + normal)

        if (prevCmp && prevCmp.ownerGrid && currCmp && currCmp.ownerGrid && prevCmp.ownerGrid === currCmp.ownerGrid) return; // Ne pas notifier si on ouvre le lookup depuis la zone edit

        if (prevCmp && prevCmp.picker && currCmp && currCmp.ownerGrid && currCmp.ownerGrid === prevCmp.picker.grid) return;

        if (currCmp !== prevCmp) {
          // console.warn('prevCmp: ' + (prevCmp && (prevCmp.$className + '/' + (prevCmp.nm || prevCmp.id) + '/' + (prevCmp.internalName || prevCmp.text || prevCmp.value))));
          // console.warn('currCmp: ' + (currCmp && (currCmp.$className + '/' + (currCmp.nm || currCmp.id) + '/' + (currCmp.internalName || currCmp.text || currCmp.value))));
          // Gestion du focus (attention ne doit pas être déclenché lors de la fermeture des modales => idem grid)
          if (prevCmp && prevCmp.wxNotifyFocusEvent) prevCmp.fireEvent('notifyBlur', prevCmp, currCmp);
          if (currCmp && currCmp.wxNotifyFocusEvent) currCmp.fireEvent('notifyFocus', currCmp);
        }
      }
    }
  },
  onComponentDestroy: function onComponentDestroy(cmp) {
    if (this.focusedCmp === cmp) {
      delete this.focusedCmp;
    }
  },
  findNext: function findNext(cmp, fwd) {
    var floating, focusables, idx, cmpeldom;
    if (cmp.focusEl && cmp.focusEl.isFocusable()) cmpeldom = cmp.focusEl.dom; // else if (cmp.el && cmp.el.isFocusable()) // A activer si nécessaire, éventuellemnt mettre en premier
    //     cmpeldom = cmp.el.dom;
    else {
        // Si le cmp n'est pas focusable, on prend le premier/dernier sous composant de celui-ci.
        // A voir l'utilité car les EditLabels sont gérés en utilsant cmp.focusEl au lieu de cmp.el
        // Le FieldHtmlEditor passe par ici (cmp.focusEl = div avec isFocusable = false, cmpeldom = iframe)
        focusables = cmp.el.findTabbableElements({
          skipSelf: true,
          skipTabGuards: true
        });

        if (fwd === false) {
          cmpeldom = focusables.shift();
        } else {
          cmpeldom = focusables.pop();
        }
      }
    if (!cmpeldom) return;
    floating = cmp.up('[floating]');
    /* query(':focusable') retourne également les composants de toolbar, les columns, tous les tabs (au lieu de
       seulement celui sélectionné)... contrairement à el.query(':focusable') de Extjs 4.x.
       Il est remplacé par findTabbableElements (qui a été overridé pour tenir compte de l'ordre de tabulation) */
    //focusables = floating && floating.el.query(':focusable');
    //focusables = floating && floating.query(':focusable');

    focusables = floating && floating.el && floating.el.findTabbableElements({
      skipSelf: true,
      skipTabGuards: true
    });

    if (focusables && focusables.length > 0) {
      idx = focusables.indexOf(cmpeldom);

      if (idx >= 0) {
        if (fwd === false) {
          --idx;
          if (idx < 0) idx = focusables.length - 1;
        } else {
          ++idx;
          if (idx === focusables.length) idx = 0;
        }

        return focusables[idx];
      }
    }
  },
  selectNext: function selectNext(cmp, fwd, selectText) {
    var next = this.findNext(cmp, fwd);

    if (next) {
      next.focus();

      if (selectText === true && next.select) {
        next.select();
      }
    }

    return next;
  },
  isParentFormActive: function isParentFormActive(cmp) {
    var form = cmp.up('[floating]');
    if (form && form.field && form.field === cmp) // Editeur du grid, remonter encore 1X
      form = form.up('[floating]'); // return (Ext.WindowManager.getActive() === form);

    return Ext.WindowManager.lastActiveForm === form;
  },
  // Pour transmettre le control ayant le focus au serveur
  // (Rechercher le composant qui existe sur le serveur (ex: grid.view => grid.panel)
  getActiveFocus: function getActiveFocus(cmp) {
    var form, focusedCmp;
    form = Ext.WindowManager.lastActiveForm;
    focusedCmp = Ext.ux.wx.FocusObserver.focusedCmp; // Dans certains cas, prendre le focus définit sur la form (ex: Btns du ribbon n'ont pas réellement le focus)
    // (cf. onComponentFocus)

    if (focusedCmp) if (focusedCmp.inRibbon || // Exclut les boutons du ribbon
    focusedCmp.ownerCt && focusedCmp.ownerCt.inRibbon || // Exclut les tabs du ribbon
    focusedCmp.parentMenu) {
      // Exclut les items de menu
      if (form && form.activeFocus) focusedCmp = form.activeFocus;
    } // If shortcuts have to be redirected (ex: comboboxGrid's picker grid view)

    if (focusedCmp && focusedCmp.getShortCutEl) {
      focusedCmp = focusedCmp.getShortCutEl() || focusedCmp;
    } // Si le composant existe sur le serveur, la propriété nm est renseignée !


    while (focusedCmp && (!focusedCmp.nm || focusedCmp.shortCutFocusable === false) && focusedCmp.ownerCt) {
      focusedCmp = focusedCmp.ownerCt;
    }

    if (!focusedCmp || !focusedCmp.nm) {
      focusedCmp = form;
    }

    return focusedCmp;
  }
});
/**
 * @class Ext.ux.wx.TranslateManager
 * @singleton
 *
 */
Ext.define('Ext.ux.wx.TranslateManager', {
  singleton: true,
  // private
  registerList: [],
  config: {
    /**
     * @cfg {Object} translations
     */
    translations: undefined
  },

  /**
   * updateTranslate
   */
  updateTranslate: function updateTranslate() {
    var me = this,
        len = me.registerList.length,
        i;

    for (i = 0; i < len; i++) {
      me.registerList[i].onTranslate();
    }
  },
  translateComponent: function translateComponent(cmp) {
    if (cmp.translate) (cmp['setText'] || cmp['setFieldLabel']).apply(cmp, [Ext.ux.wx.TranslateManager.getWord(cmp.translateKey || cmp.translate, cmp.translate)]);
    if (cmp.items && cmp.items.items && Array.isArray(cmp.items.items)) cmp.items.items.forEach(item => {
      Ext.ux.wx.TranslateManager.translateComponent(item);
    });
    if (cmp.dockedItems) cmp.dockedItems.items.forEach(item => {
      Ext.ux.wx.TranslateManager.translateComponent(item);
    });
  },
  // private
  getWord: function getWord(word, value) {
    var me = this;
    return me.getTranslations() && me.getTranslations()[word] || value || word;
  },
  // private
  register: function register(cmp) {
    var me = this;
    Ext.Array.push(me.registerList, cmp);
    cmp.onTranslate();
  },
  // private
  unregister: function unregister(cmp) {
    var me = this;
    Ext.Array.remove(me.registerList, cmp);
  }
});
/**
 * @class Ext.ux.wx.overrides.Component
 */
Ext.define('Ext.ux.wx.overrides.Component', {
  override: 'Ext.Component',
  config: {
    // prevent XSS cf. https://www.sencha.com/forum/showthread.php?13913-Security-XSS-attacks-for-Extjs-Applications-critical-warning/page19
    allowMarkup: false
  },
  privates: {
    // prevent XSS
    doRenderContent: function doRenderContent(out, renderData) {
      var me = renderData.$comp,
          html = me.html;

      if (html && !me.getAllowMarkup()) {
        me.html = Ext.String.htmlEncode(html);
      }

      me.callParent([out, renderData]);
    }
  },
  // prevent XSS
  update: function update(htmlOrData, loadScripts, callback) {
    if (htmlOrData && Ext.isString(htmlOrData) && !this.getAllowMarkup()) {
      htmlOrData = Ext.String.htmlEncode(htmlOrData);
    }

    this.callParent([htmlOrData, loadScripts, callback]);
  },
  // override
  statics: {
    flushLayouts: function flushLayouts() {
      var me = this;
      Ext.ux.wx.DebugLogs.debugLayout(me.pendingLayouts);
      me.callParent(arguments);
    }
  },
  // override 6.5.3
  hide: function hide() {
    var me = this; // hide du lookup alors que celui-ci est déjà détruit => error viewConfig

    if (!me.destroyed) me = this.callParent(arguments);
  },
  initInheritedState: function initInheritedState(inheritedState) {
    var me = this; // More information to debug error viewConfig

    if (me.destroyed) Ext.log.error('Call to initInheritedState with destroyed component ' + me.$className + '/' + (me.nm || me.id) + '/' + me.internalName);
    me.callParent(arguments);
  },
  // override
  afterRender: function afterRender() {
    var me = this;
    me.callParent(arguments); // Ajout des informations pour le debug et les tests automatiques AQ

    if (me.el && me.el.dom) {
      if (me.internalName) me.el.dom.setAttribute('data-internalname', me.internalName);else if (me.itemId) // utilisation itemId des menus (ex: menu de la column d'un grid)
        me.el.dom.setAttribute('data-internalname', me.itemId);
      if (me.internalClassName) me.el.dom.setAttribute('data-internalclassname', me.internalClassName);
      if (me.nm) me.el.dom.setAttribute('data-nm', me.nm);
    }
  },

  /**
   * focusControl
   * @param {Boolean} [selectText=false] to select the text after focus
   * @return {Ext.Component}
   */
  focusControl: function focusControl(selectText) {
    //ACT_DOCUMENT, "DIV saisie globale", positionné sur numéro de compte, ctrl+Insert ne change pas le statut de hasFocus
    //bug ExtJS: http://www.sencha.com/forum/showthread.php?265881 -> corrigé par EXTJS-10221 en 6.0.1.250.
    // focus avec un délai sinon plusieurs controls peuvent être focusé en même temps (DOC_DOCUMENT_MANAGEMENT,
    // onglet en-tête au 1er affichage) -> ne semble plus poser problème.
    // return me.focus(selectText, true);
    // Supprimer le delay pour corriger ce problème:
    // ACT_DOCUMENT + Insertion + focus dans le grid + annuler => le focus n'est pas dans la zone de recherche
    // De plus lockMask prend désormais le focus (peut causer des effets de bord)
    return this.focus(selectText);
  },
  //override
  // Bloque le scroll auto sous WebKit (Chrome/Safari)
  focus: function focus(selectText, delay, callback, scope) {
    var me = this,
        x,
        y; // Chrome (et Safari -> donc WebKit) scrolle sur le composant prenant le focus, ce qui pose problème pour cliquer sur certains éléments.
    // Il n'est pas possible de faire un click sur un bouton (fermer par exemple) par exemple, ou de double-cliquer sur le
    // bon enregistrement d'un grid.
    // On enregistre et restaure donc la position du scroll telle qu'avant le focus (pour les listview/gridview/treeview).
    // Attention, si un délai est spécifié, il faut restaurer la position après l'exécution réelle du focus (second appel à focus avec delay=false)

    if (Ext.isWebKit
    /* Utiliser (Ext.isChrome || Ext.isSafari) si besoin */
    && me.lockWindowScrollOnFocus && !delay) {
      x = window.scrollX;
      y = window.scrollY;
      me.callParent(arguments); // Exemple concrêt :
      // Documents (navigateur maximisé) -> Interroger -> Compte créancier -> Détail -> mettre le focus dans le grid
      // Dimensionner la fenêtre du navigateur de façon à ce qu'on ne voie plus le grid, déplacer les scrollbars
      // tout en haut et à droite, tenter de cliquer sur la croix de fermeture des documents comptables : si le
      // problème est présent, la page scrolle pour afficher le grid et le clic n'est pas pris en compte.
      // -> Ce problème n'est plus présent avec ExtJS 6.5 pour le clic du bouton fermer, mais il se produit
      // encore dans le même cas si on clique dans une zone vide (du ribbon ou d'un panel).

      if (x !== window.scrollX || y !== window.scrollY) {
        window.scrollTo(x, y);
      }

      return me;
    } else {
      return me.callParent(arguments);
    }
  }
}); // Bug ExtJs : les masks ne sont pas redimensionnés lorsque invisibles (visibility: hidden) et générent des scrollbars
//  -> corrigé avec ExtJS 6.5 (utilisation de 100% pour les dimensions)

Ext.define('Ext.ux.wx.overrides.LoadMask', {
  override: 'Ext.LoadMask',
  // Si le mask prend le focus, ça génère des effets de bords, notamment avec les LK
  focusable: false,
  // override 6.5.3
  afterRender: function afterRender() {
    var me = this,
        internalName;

    if (me.target) {
      if (me.target.ownerGrid) {
        // For a grid/tree we need to find panel or owner panel internalName
        // Warning: LockGrid view as internalName BANDED_VIEW_normal => First test ownerGrid
        if (me.target.ownerGrid.internalName === 'BANDED_VIEW' && me.target.ownerGrid.ownerCt) internalName = me.target.ownerGrid.ownerCt.internalName;else internalName = me.target.ownerGrid.internalName;
      } else if (me.target.internalName) internalName = me.target.internalName;

      if (internalName) me.internalName = internalName + '_loadMask';
    }

    me.callParent(arguments);
  },
  // override 6.5.3
  getMaskTarget: function getMaskTarget() {
    var me = this,
        result;
    /*MOD PCS: if lockable use normal view and not grid to avoid focus issue*/

    if (!me.isElement && me.wxTarget) result = me.wxTarget.getMaskTarget();
    if (!result)
      /*END MOD*/
      result = me.callParent(arguments);
    return result;
  } //     sizeMask: function() {
  //         [...]
  //     }

});
/* Bug focus cyclique sur les modales : les composants ne sont pas triés selon le tabIndex.
   [4.2.1] Focus wrapping round in modal windows doesn't consider tabindex value
   http://www.sencha.com/forum/showthread.php?267077-4.2.1-Focus-wrapping-round-in-modal-windows-doesn-t-consider-tabindex-value&p=979327
   Avec Extjs 6.5, le problème a été déplacé mais est toujours présent, on corrige findTabbableElements (aussi utilisé
   par FocusObserver.findNext.
 */

/**
 * @class Ext.ux.wx.overrides.dom.Element
 */

Ext.define('Ext.ux.wx.overrides.dom.Element', {
  override: 'Ext.dom.Element',
  // override 6.5.3
  inheritableStatics: {
    unmaskIframes: function unmaskIframes() {
      /*MOD PCS: A quoi ça sert ?
          pose problème lors du déplacement des modales, les composants des autres formes deviennent accessible par tab !*/

      /*END MOD*/
      var iframes = document.getElementsByTagName('iframe'),
          fly = new Ext.dom.Fly();
      Ext.each(iframes, function (iframe) {
        /*MOD PCS: Ajout d'une condition, est-ce suffisant ? */
        if (iframe.contentDocument && iframe.contentDocument.body && iframe.contentDocument.body.childElementCount) {
          /*END MOD*/
          fly.attach(iframe.parentNode).unmask();
        }
      });
    },
    // override 6.5.3
    maskIframes: function maskIframes() {
      /*MOD PCS: A quoi ça sert ?
          pose problème lors du déplacement des modales, les composants des autres formes deviennent accessible par tab !*/

      /*END MOD*/
      var iframes = document.getElementsByTagName('iframe'),
          fly = new Ext.dom.Fly();
      Ext.each(iframes, function (iframe) {
        var myMask;
        /*MOD PCS: Ajout d'une condition, est-ce suffisant ? */

        if (iframe.contentDocument && iframe.contentDocument.body && iframe.contentDocument.body.childElementCount) {
          /*END MOD*/
          myMask = fly.attach(iframe.parentNode).mask();
          myMask.setStyle('background-color', 'transparent');
        }
      });
    }
  },
  privates: {
    findTabbableElements: function findTabbableElements(options) {
      // Différentes variantes sont disponibles en fonction de l'avancement des composant complexes.
      // Pour l'instant on ignore les comopsants avec tabIndex = 0 si options.skipSelf = true mais c'est du
      // bricolage.
      // options.skipTabGuards est utilisé par FocuObserver.findNext. A voir s'il faut remonter le filtre dans le
      // FocuObserver pour enlever seulement le premier élément (si égal à cmp.tabGuardBeforeEl) et dernier
      // élément (si égal à cmp.tabGuardAfterEl) ou si on doit continuer à tous les enlever.
      // Variante complète temporaire, ne peut pas être appliquée dans tous les cas, le test sur skipSelf est un
      // coup de bol (sinon changement de comportement de saveTabbableState et du tabIndex sur le td des gridviews)
      if (options && options.skipSelf) {
        var result = this.callParent(arguments);
        result = Ext.Array.filter(result, function (item) {
          if (item.type === 'radio' && !item.checked && item.name) return false; // Seul le radio-bouton coché prend le focus dans un group de radio-boutons
          else return item.tabIndex > 0;
        });

        if (options.skipTabGuards) {
          result = Ext.Array.filter(result, function (item) {
            return !item.classList.contains(Ext.baseCSSPrefix + 'tab-guard');
          });
        }

        result = Ext.Array.sort(result, function (item1, item2) {
          return item1.tabIndex - item2.tabIndex;
        });
        return result;
      } // Variante sans filtre TabGuards
      // if (options && options.skipSelf) {
      //     return Ext.Array.sort(
      //            Ext.Array.filter(
      //             this.callParent(arguments),
      //             function (item) {return item.tabIndex > 0;}),
      //             function (item1, item2) {return item1.tabIndex - item2.tabIndex;});
      // }
      // Variante en positionnant les composants avec tabIndex à 0 juste avant le TabGuard (32767)


      return Ext.Array.sort(this.callParent(arguments), function (item1, item2) {
        return (item1.tabIndex === 0 ? 32766 : item1.tabIndex) - (item2.tabIndex === 0 ? 32766 : item2.tabIndex);
      }); // Variante minimun, tri sur tabindex
      // return Ext.Array.sort(
      //         this.callParent(arguments),
      //         function (item1, item2) {return item1.tabIndex - item2.tabIndex;});
    }
  }
});
Ext.define('Ext.ux.wx.overrides.XTemplate', {
  override: 'Ext.XTemplate',
  applyOut: function applyOut(values, out, parent, xindex, xcount) {
    var me = this,
        compiler;

    if (!me.fn) {
      compiler = new Ext.util.XTemplateCompiler({
        useFormat: me.disableFormats !== true,
        definitions: me.definitions,
        strict: me.strict
      });
      me.fn = compiler.compile(me.html);
    } // xindex is 1-based, so 0 is impossible


    xindex = xindex || 1; // likewise, this tpl exists in the parent, so xcount==0 is not possible

    xcount = xcount || 1;

    if (me.strict) {
      me.fn(out, values, parent || me.emptyObj, xindex, xcount);
    } else {
      try {
        me.fn(out, values, parent || me.emptyObj, xindex, xcount);
      } catch (e) {
        Ext.log.warn('XTemplate evaluation exception: ' + e.message);
        /*MOD PCS: log callstack !*/

        if (e.stack) {
          if (e.stack.stack) e.stack = e.stack.stack; // in Chrome stack is in property error.stack.stack when call from try...catch

          Ext.log.warn(e.stack);
        } // if (e.wxError)


        Ext.ux.wx.DebugManager.errorHandler(e);
        /*END MOD*/
      }
    }

    return out;
  }
});
Ext.define('Ext.ux.wx.overrides.MessageBox', {
  override: 'Ext.window.MessageBox',
  initComponent: function initComponent() {
    var me = this;
    me.callParent(arguments); // Activer en permanence la mise en valeur du composant ayant le focus (cf. form.js)

    me.bottomTb.addCls(Ext.baseCSSPrefix + 'keyboard-mode'); // Autoriser le code html pour les messages (Erreur, SessionManager...)

    me.msg.setAllowMarkup(true);
  },
  reconfigure: function reconfigure(cfg) {
    const me = this;
    me.callParent(arguments);
    /*MOD PCS: wxAutoDestroy */
    // [X] or ESC call close() (and optionally destroy)
    // Click or Space on button don't call close, therefore no destroy !
    // => wxAutoDestroy force close and destroy (don't do that with singleton, not destroy singleton !)

    const cb = me.userCallback;

    me.userCallback = function () {
      try {
        me.wxCallBackProcessing = true;
        cb.apply(me, arguments); // if not destroyed, call close to destroy it now

        if (me.wxAutoDestroy && !me.destroying && !me.destroyed) me.close();
      } finally {
        delete me.wxCallBackProcessing;
      }
    };
    /*END MOD*/

  },
  onClose: function onClose() {
    const me = this;
    if (me.wxAutoDestroy) me.closeAction = 'destroy';
    /*MOD PCS: Close() call btnCallBack('cancel').  Don't call it if already called from btnCallBack !*/

    if (!me.wxCallBackProcessing) me.callParent(arguments);
    /*END MOD*/
  },
  onEsc: function onEsc() {
    if (this.closable !== false) {
      /*MOD PCS: missing return false => warning in console*/
      // this.callParent(arguments);
      return this.callSuper(arguments);
      /*END MOD*/
    }
  }
});
/**
 * @class Ext.ux.wx.WebSocketBuffer
 */
Ext.define('Ext.ux.wx.WebSocketBuffer', {
  //firstId: undefined,
  items: [],
  cptMsgId: 0,
  bufferLength: 100,
  // id consécutif de messages
  // on ne garde que les n derniers
  constructor: function constructor(config) {
    if (config) Ext.apply(this, config);
  },
  procMessages: function procMessages(from, func, scope) {
    var me = this,
        i;
    if (!me.bufferLength) return false; // Rien a été envoyé !

    if (me.firstId === from === undefined) return true;
    i = from - me.firstId;

    if (i > -1 && i < me.bufferLength) {
      for (; i < me.items.length; i++) {
        func.call(me, me.items[i].msg);
      }

      return true;
    }

    return false;
  },
  clear: function clear() {
    var me = this;
    me.items = [];
    me.cptMsgId = 0;
    delete me.firstId;
  },
  add: function add(msg) {
    var me = this;
    if (!me.bufferLength) return msg;
    ++me.cptMsgId;
    msg += (Ext.String.endsWith(msg, '&') ? '' : '&') + 'MsgId=' + me.cptMsgId; // ne conserver que les 100 derniers messages

    if (me.items.length > 100) {
      me.items.shift();
    }

    me.items.push({
      id: me.cptMsgId,
      msg: msg
    });
    me.firstId = me.items[0].id;
    return msg;
  }
});
/**
 * @class Ext.ux.wx.WebSocketSingleton
 *
 * The WebSocketSingleton is responsible for globally:
 *
 * @singleton
 */
Ext.define('Ext.ux.wx.WebSocketSingleton', {
  singleton: true,
  retryDelay: 500,
  retryMaxAttempt: 5,
  stallingDelay: 10000,
  pingDelay: 0,
  //stallingCancelUrl: undefined,
  //stallingCancelParams: undefined,
  lastRecvMsgId: 0,
  constructor: function constructor(config) {
    var TWSEvent = Ext.extend(Ext.mixin.Observable, {
      constructor: function constructor(config) {
        this.name = config.name;
        wxAddEvents({
          "OnWSOpen": true,
          "OnWSBeforeMessage": true,
          "OnWSAfterMessage": true,
          "OnWSClose": true
        });
        this.listeners = config.listeners;
        TWSEvent.superclass.constructor.call(this, config);
      }
    });
    window.wsEvents = this.wsEvents = new TWSEvent({});
    this.superclass.constructor.call(this, config);
    this.outBuffer = new Ext.ux.wx.WebSocketBuffer({
      bufferLength: 0
    }); // Pas de buffer par défaut
    // used for stalling

    this.lastRecvMsgDate = 0;
    this.msgDataHandler = Ext.ux && Ext.ux.wx && Ext.ux.wx.debugJS ? this.doHandleDataDebug : this.doHandleData;
  },
  setOutBufferLength: function setOutBufferLength(value) {
    this.allowReconnect = value != 0;
    this.outBuffer.bufferLength = value;
  },

  /**
   * @private
   */
  ws: null,
  wsEvents: null,
  doHandleData: function doHandleData(data) {
    try {
      if (Ext.ux.wx.ApplicationManager.getAutoLockLayoutWS()) Ext.suspendLayouts();
      Ext.ux.wx.DebugLogs.writeComData('RECEIVE', data);
      executeJS(data);
      if (Ext.ux.wx.ApplicationManager.getAutoLockLayoutWS()) Ext.resumeLayouts(true);
    } catch (err) {
      Ext.ux.wx.DebugManager.errorHandler(err, data);
    }
  },
  doHandleDataDebug: function doHandleDataDebug(data) {
    var me = this,
        msgIndex = '' + (me.lastRecvMsgId + 1);

    try {
      if (Ext.ux.wx.ApplicationManager.getAutoLockLayoutWS()) Ext.suspendLayouts();
      Ext.ux.wx.DebugLogs.writeComData('RECEIVE', data);
      const t0 = performance.now();
      executeJS(data + '\n//# sourceURL=execute-' + msgIndex.padStart(5, '0') + '.js\n');
      if (Ext.ux.wx.ApplicationManager.getAutoLockLayoutWS()) Ext.resumeLayouts(true);
      const duration = Ext.Number.roundToPrecision(performance.now() - t0, 3);
      if (duration > 500) console.warn("RECEIVED message ".concat(me.lastRecvMsgId, ", duration ").concat(duration, " eval OK"));else console.log("RECEIVED message ".concat(me.lastRecvMsgId, ", duration ").concat(duration, " eval OK"));
    } catch (err) {
      Ext.ux.wx.DebugManager.errorHandler(err, data);
    }
  },

  /**
   * @private
   */
  createInstance: function createInstance(port, host, ssl) {
    // Multi-port mode
    //var url = "ws://" + host + ":" + port + "/";
    // Redirected from http port mode (only same host)
    var url;

    if (host) {
      url = (ssl ? "wss://" : "ws://") + window.location.host + "/websockets/" + host + "/" + port;
    } else {
      url = (ssl ? "wss://" : "ws://") + window.location.host + "/websockets/" + port;
    }

    if ("WebSocket" in window) {
      return new WebSocket(url);
    } else if ("MozWebSocket" in window) {
      return new MozWebSocket(url);
    } else {
      return null;
    }
  },

  /**
   * @private
   */
  doWSOnOpen: function doWSOnOpen() {
    // Remark : this = websocket instance
    var me = Ext.ux.wx.WebSocketSingleton;
    me.lastRecvMsgDate = 0;
    me.retryAttempt = me.retryAttempt || 0;

    if (me.reconnecting) {
      // Si on est en cours de reconnexion après une perte de celle-ci (donc sans regenerate de la page complète)
      // on doit envoyer notre lastSenderId pour prouver que c'est bien le même onglet qui se reconnecte, et enlever
      // le masque affiché à la perte de connexion.
      me.send('PathInfo=reconnectSender&LastSenderId=' + me.lastSenderId + '&LastRecvMsgId=' + me.lastRecvMsgId, true);
    } else {
      delete me.wsMsgOnClose;

      if (me.connecting) {
        delete me.connecting;
      } // Nvlle connection: on vide le buffer


      me.outBuffer.clear();

      if (me.wsEvents !== null) {
        me.wsEvents.fireEvent('OnWSOpen', this);
      } else {// ToDo : alert the user
      }
    }

    var loadingItem = Ext.get("loading");

    if (loadingItem && Ext.select(".x-window").elements.length > 0) {
      // On cache le loading dès qu'une fenêtre existe, mais pas avant
      loadingItem.setVisible(false);
    }
  },

  /**
   * @private
   */
  doWSOnMessage: function doWSOnMessage(msg) {
    // Remark : this = websocket instance
    var me = Ext.ux.wx.WebSocketSingleton;
    me.wsEvents.fireEvent('OnWSBeforeMessage', this, msg);

    if (msg.data) {
      me.updateStallingData();
      if (me.msgDataHandler) me.msgDataHandler(msg.data); // call to doHandleData or doHandleDataDebug
    }

    var loadingItem = Ext.get("loading");

    if (loadingItem && Ext.select(".x-window").elements.length > 0) {
      // On cache le loading dès qu'une fenêtre existe, mais pas avant
      loadingItem.setVisible(false);
    } // Si le message envoyé est la fermeture de la fenêtre (window.close;), wsEvents se retrouve indéfini ici !
    // Problème visible avec mode ouverture dans un nvl onglet et firefox


    if (typeof me.wsEvents != "undefined") {
      me.wsEvents.fireEvent('OnWSAfterMessage', this, msg);
    }
  },

  /**
   * @private
   */
  doWSOnClose: function doWSOnClose(event) {
    // Remark : this = websocket instance
    var me = Ext.ux.wx.WebSocketSingleton,
        closeReason = me.closeReason;
    console.log("WEBSOCKET OnClose code/wasClean: " + event.code + "/" + event.wasClean);

    if (me.forceReloadOnClose) {
      me.checkNetworkAndProcess('reload');
      return;
    } // Si c'est l'échec d'une reconnexion ou une fermeture explicite, on accepte cette fermeture, sinon
    // on essaie de se reconnecter
    // Ne pas se reonnecter si c'est pas autorisé (SessionMngr ne gère pas la méthode reconnectSender)


    if (me.connecting || me.reconnecting && me.retryAttempt > me.retryMaxAttempt || me.closing || !me.allowReconnect) {
      delete me.closeReason;
      delete me.closing;

      if (me.wsEvents !== null) {
        me.wsEvents.fireEvent('OnWSClose', this);

        if (closeReason === 'logout') {
          me.showLogout();
        } else if (me.wsShowMsgOnClose) {
          me.showCloseMessage();
        }
      }
    } else {
      // Si c'est la première tentative de reconnection on ne met pas de délai
      setTimeout(function () {
        me.reconnect();
      }, me.retryAttempt * me.retryDelay);
    }
  },

  /**
   * @private
   */
  doWSOnError: function doWSOnError(event) {
    // Remark : this = websocket instance
    var me = Ext.ux.wx.WebSocketSingleton;

    if (me.wsShowMsgOnClose) {
      if (!me.wsMsgOnClose) {
        me.wsMsgOnClose = Ext.ux.wx.TranslateManager.getWord("wsError", "Error occurred.");
      } //            else {
      //                me.wsMsgOnClose += '<br/>('+Ext.ux.wx.TranslateManager.getWord("wsError", "Error occurred.")+')';
      //            }

    }
  },

  /**
   * Property
   */
  wsContext: "",
  wsShowMsgOnClose: true,
  wsMsgOnClose: "",
  showSource: null,
  showError: null,

  /**
   * @public
   */
  connect: function connect(port, host) {
    var me = this; // Create an instance of WebSocket

    if (me.ws === null) {
      if (port <= 0) {
        port = 80;
      }

      var vhost;

      if (host === undefined) {
        vhost = window.location.host;
        var iPos = vhost.indexOf(":");

        if (iPos > 0) {
          vhost = vhost.substring(0, iPos);
        }
      } else {
        vhost = host;
      } // Bakup connection infos for reconnection in case of connexion failure


      me.connectionInfos = {};
      me.connectionInfos.port = port;
      me.connectionInfos.host = vhost;
      me.connectionInfos.ssl = window.location.protocol == 'https:';
      me.connecting = true;
      me.ws = me.createInstance(port, vhost, window.location.protocol == 'https:');

      if (me.ws !== null) {
        // If error while trying to connect, doWSOnOpen is called, so we set user message here :
        me.wsShowMsgOnClose = true;
        me.wsMsgOnClose = Ext.ux.wx.TranslateManager.getWord("wsOpenFailed", "The connection cannot be established."); // Define the callbacks for the events of WebSocket

        me.ws.onopen = me.doWSOnOpen; // Called after connection is established

        me.ws.onmessage = me.doWSOnMessage; // Called when receive message

        me.ws.onclose = me.doWSOnClose; // Called when connection is closed

        me.ws.onerror = me.doWSOnError; // Called when error occurred

        return true;
      } else {
        // Cannot create an instance
        return false;
      }
    } else {
      me.ws.onopen = null;
      me.ws.onmessage = null;
      me.ws.onclose = null;
      me.ws.onerror = null;
      me.close();
      me.ws = null;
      me.connect(port, host); // ToDo : Try to check if client is connected to server already
    }

    return true;
  },

  /**
   * @private
   */
  reconnect: function reconnect() {
    var me = this;
    me.retryAttempt += 1;
    Ext.ux.wx.LockMaskManager.showLockMask();
    me.reconnecting = true; // ReCreate an instance of WebSocket

    me.ws = me.createInstance(me.connectionInfos.port, me.connectionInfos.host, me.connectionInfos.ssl);

    if (me.ws !== null) {
      // If error while trying to connect, doWSOnOpen is called, so we set user message here :
      me.wsShowMsgOnClose = true;
      me.wsMsgOnClose = Ext.ux.wx.TranslateManager.getWord("wsLost", "The connection was lost and can not be restored.<br/>Try to restore the connection or restart the application."); // Define the callbacks for the events of WebSocket

      me.ws.onopen = me.doWSOnOpen; // Called after connection is established

      me.ws.onmessage = me.doWSOnMessage; // Called when receive message

      me.ws.onclose = me.doWSOnClose; // Called when connection is closed

      me.ws.onerror = me.doWSOnError; // Called when error occurred

      return true;
    } else {
      // Cannot create an instance
      return false;
    }
  },

  /**
   * Server accept WS reconnect
   * @param lastSenderId   newSenderId du client
   * @param lastSendMsgId  dernier message envoyé par le client
   */
  acceptWSReconnect: function acceptWSReconnect(lastSenderId, lastSendMsgId) {
    var me = this;
    me.lastSenderId = lastSenderId;
    me.retryAttempt = 0;
    delete me.wsMsgOnClose;
    delete me.reconnecting;
    delete me.forceReloadOnClose; // ré-envoyer les messages non-recus

    if (!lastSendMsgId || me.outBuffer.procMessages(lastSendMsgId + 1, Ext.bind(me.send, me, [true], true), me)) {
      Ext.ux.wx.LockMaskManager.hideLockMask();
    } else {
      // Buffer not large enough
      console.log("WEBSOCKET Buffer not long enough. Messages lost from: " + lastSendMsgId);
      me.refuseWSReconnect(true);
    }
  },

  /**
   * Server or client refuse WS reconnect
   */
  refuseWSReconnect: function refuseWSReconnect(needReload) {
    // Attention appelée par Client et Server
    var me = this;
    me.needReload = needReload;
    delete me.reconnecting;
    me.close("lost");
  },
  setPingDelay: function setPingDelay(value) {
    // Appelé à l'ouverture (cf. TwxApplication.DoConnectTo)
    this.pingDelay = value;
    this.callPing();
  },
  callPing: function callPing(abort) {
    var me = this;

    if (me.pingDelay && !abort) {
      if (!me.pingTask) me.pingTask = new Ext.util.DelayedTask(me.send, me, ['ping', true, true]);
      me.pingTask.delay(me.pingDelay);
    } else if (me.pingTask) me.pingTask.cancel();
  },

  /**
   * Envoie d'un message
   * @public
   */
  send: function send(msg, disableBuffer, disableLog) {
    var me = this; // ajout au buffer + numérotation

    if (!disableBuffer) msg = me.outBuffer.add(msg);

    if (
    /*Ext.ux && Ext.ux.wx && Ext.ux.wx.debugJS &&*/
    !disableLog) {
      // Aso used by release mode (see DebugManager)
      Ext.ux.wx.DebugLogs.writeComData('SEND', me.wsContext + msg);
    }

    if (me.ws.readyState > 1) {
      if (!disableLog) console.log("SENDING aborted: Communication link isn't active (readyState: " + me.ws.readyState + ").");
      me.callPing(true);
      return;
    }

    try {
      me.callPing();
      me.ws.send(me.wsContext + msg);
    } catch (exception) {
      console.error("SEND exception : " + exception.message);
    }
  },

  /**
   * Protected (for ApplicationManager and TwxApplication use)
   * Attention au /Amin
   */
  close: function close(reason) {
    var me = this;

    if (me.ws && me.ws.readyState == me.ws.OPEN) {
      me.closing = true;
      me.closeReason = reason;

      if (me.closeReason === "kill") {
        Ext.ux.wx.LockMaskManager.showLockMask(); // s'assurer qu'en cas de kill par le server, le client soit bloqué par un mask

        me.wsMsgOnClose = Ext.ux.wx.TranslateManager.getWord("wsKill", "The application was killed by the server.");
      } else if (me.closeReason === "lost") {
        Ext.ux.wx.LockMaskManager.showLockMask(); // s'assurer que si la reconnection est refusée, le client soit bloqué par un mask

        me.wsMsgOnClose = Ext.ux.wx.TranslateManager.getWord("wsLost", "The connection was lost and can not be restored.<br/>Try to restore the connection or restart the application.");
      } //else if (me.closeReason === "logout")
      // => Ext.ux.wx.WindowLogOut
      // Reconnection dans un autre onglet. (Ex: 1.Open Object 2.Open Admin 3.Connect)
      else if (me.closeReason === "reconnect") {
          Ext.ux.wx.LockMaskManager.showLockMask(); // s'assurer que si on se reconnect dans un autre onlet, l'ancien onglet soit bloqué par un mask

          me.wsMsgOnClose = Ext.ux.wx.TranslateManager.getWord("wsReconnect", "The connection was closed because the application has been displayed in another page.");
        }

      me.ws.close();
    }
  },
  showLogout: function showLogout() {
    var me = this;
    Ext.Msg.show({
      title: Ext.ux.wx.TranslateManager.getWord('wsLogoutTitle', 'Session logout'),
      icon: Ext.Msg.INFO,
      msg: Ext.ux.wx.TranslateManager.getWord('wsLogout', 'You have been successfully disconnected.'),
      buttons: Ext.Msg.YESNO,
      buttonText: {
        yes: Ext.ux.wx.TranslateManager.getWord('wsLogoutBtnReconnect', "Reconnect"),
        no: Ext.ux.wx.TranslateManager.getWord('wsLogoutBtnClose', "Close")
      },
      closable: false,
      fn: function fn(buttonId) {
        if (buttonId === 'yes') window.location.reload(true);else if (buttonId === 'no') closeWindow();
      },
      scope: me
    });
  },

  /**
   * Affiche les messages de perte de connexion
   * @private
   */
  showCloseMessage: function showCloseMessage() {
    var me = this;

    if (!me.wsMsgOnClose) {
      me.wsMsgOnClose = Ext.ux.wx.TranslateManager.getWord("wsConnectCancel", "The connection was canceled by server.");
    }

    Ext.Msg.show({
      title: Ext.ux.wx.TranslateManager.getWord("wsCloseTitle", "Connection failure"),
      msg: me.wsMsgOnClose,
      icon: Ext.Msg.WARNING,
      buttons: Ext.Msg.YESNO + Ext.Msg.CANCEL,
      buttonText: {
        yes: Ext.ux.wx.TranslateManager.getWord('wsBtnRestore', "Restore"),
        no: Ext.ux.wx.TranslateManager.getWord('wsBtnRestart', "Restart"),
        cancel: Ext.ux.wx.TranslateManager.getWord('wsBtnClose', "Close")
      },
      closable: false,
      fn: function fn(buttonId) {
        var action;

        switch (buttonId) {
          case 'yes':
            action = 'reconnect';
            break;

          case 'no':
            action = 'restart';
            break;

          case 'cancel':
            action = 'close';
            break;

          default:
            return;
        }

        if (action == 'reconnect' || action == 'close') {
          // L'essai de reconnection de la websocket et la fermeture de la page ne nécessitent
          // pas le test d'accessibilité du SessionManager
          me.processCloseAction(action);
        } else {
          // On teste l'accessibilité du SessionManager puis on traite l'action
          me.checkNetworkAndProcess(action);
        }
      },
      scope: me
    });
  },

  /**
   * Teste l'accessibilité du SessionManager
   * On pourrait ramplacer le paramètre par deux callbacks
   * @private
   */
  checkNetworkAndProcess: function checkNetworkAndProcess(action)
  /*(fnSuccess, fnFailure)*/
  {
    var me = this;
    Ext.Ajax.request({
      method: "GET",
      url: me.stallingCancelUrl || window.location.pathname.replace('Admin', 'Action'),
      params: {
        ping: 1
      },
      success: function success(response, opts) {
        me.processCloseAction(action);
      },
      failure: function failure(response, opts) {
        console.log("server-side failure with status code " + response.status);
        console.log(response);
        me.wsMsgOnClose = Ext.ux.wx.TranslateManager.getWord("wsUnavailable", "Server isn't accessible or didn't respond.<br/>Please check your network connectivity or try later.");
        me.showCloseMessage();
      }
    });
  },

  /**
   * Effectue l'action demandée par l'utilisateur lors de la perte de connexion
   * @private
   */
  processCloseAction: function processCloseAction(action) {
    var me = this;

    if (action == 'reconnect') {
      // La reconnexion de websocket n'est autorisée que lors de la perte de connexion, pas si l'appilcation a
      // été affichée dans un autre onglet
      if (me.reconnecting && !me.needReload) {
        // On essaie une fois de reconnecter la websocket, et si ça ne fonctionne pas, on rechargera la page
        me.forceReloadOnClose = true;
        me.reconnect();
      } else {
        // On doit recharger la page (avec test du SessionManager)
        me.checkNetworkAndProcess('reload');
      }
    } else if (action == 'reload') {
      // On recharge directement la page
      window.location.reload(true);
    } else {
      if (me.reconnecting) {
        // On kill l'instance avant de continuer
        me.stallingCancelRequest(false);
      } // Utilisation d'un timeout pour laisser le temps à la requête de kill de s'exécuter


      if (action == 'restart') {
        setTimeout(function () {
          // On remplace InsKey pour démarrer une nouvelle instance
          window.location.replace(window.location.href.replace('InsKey=', 'PrevInsKey='));
        }, 500);
      } else if (action == 'close') {
        setTimeout(function () {
          closeWindow();
        }, 500);
      }
    }
  },

  /**
   * Appel d'une fonction callback si pas de réception de message reçu durant le temps timeout
   * @private
   */
  stallingSentinel: function stallingSentinel() {
    var me = this;
    if (!me.stallingTask) me.stallingTask = new Ext.util.DelayedTask(me.stallingCheck, me, [Date.now()]);else me.stallingTask.cancel();
    me.stallingTask.delay(me.stallingDelay);
  },

  /**
   * Màj de la date de la dernière communication avec le serveur.
   * Si le message de demande de relance de l'objet est affiché, le fermé.
   * @private
   */
  updateStallingData: function updateStallingData() {
    var me = this;
    me.lastRecvMsgDate = Date.now(); // close the msg if already displayed

    if (me.stallingAskCancelMsg) {
      // close() call the button handler that set stallingAskCancelMsg to null
      me.stallingAskCancelMsg.close();
    }
  },

  /**
   * Test si le délai d'attente d'une réponse est dépassé et dans ce cas affiche le message
   * de demande de relance de l'objet.
   * @private
   */
  stallingCheck: function stallingCheck(date) {
    var me = this;

    if (me.lastRecvMsgDate < date) {
      me.stallingAskCancel();
    }
  },

  /**
   * Envoie la demande de relance de l'objet au serveur par un POST
   * @private
   */
  stallingCancelRequest: function stallingCancelRequest(reload) {
    var me = this;

    if (me.stallingCancelUrl) {
      Ext.Ajax.request({
        method: "POST",
        url: me.stallingCancelUrl,
        params: me.stallingCancelParams,
        success: function success(response, opts) {
          if (reload) window.location.reload(true);
        },
        failure: function failure(response, opts) {
          console.log("server-side failure with status code " + response.status);
          console.log(response);
        }
      });
    }
  },

  /**
   * Affichage question demande de relance de l'objet
   * @private
   */
  stallingAskCancel: function stallingAskCancel() {
    var me = this;
    me.stallingAskCancelMsg = new Ext.window.MessageBox({
      wxAutoDestroy: true
    }).show({
      title: Ext.ux.wx.TranslateManager.getWord("Error"),
      msg: Ext.ux.wx.TranslateManager.getWord("wsStalling", "The application is not responding, do you want to kill it and start a new one ?"),
      icon: Ext.Msg.WARNING,
      buttons: Ext.Msg.YESNO,
      closable: false,
      fn: function fn(buttonId) {
        me.stallingAskCancelMsg = null;

        if (buttonId === "yes") {
          me.stallingCancelRequest(true);
        } else if (buttonId === "no") {
          me.stallingSentinel();
        }
      },
      scope: me
    });
  }
});
/**
 * @class Ext.ux.wx.SplashBaseForm
 */
Ext.define('Ext.ux.wx.SplashBaseForm', {
  extend: 'Ext.window.Window',
  //TODO: Ext.ux.wx.Form ?
  shadow: false,
  // Pas d'ombre
  header: false,
  // Pas de barre de titre
  cls: Ext.baseCSSPrefix + 'splash-form',
  closable: false,
  resizable: false,
  closeAction: 'destroy',
  plain: true,
  border: false,
  width: 600,
  height: 340,
  layout: {
    type: 'hbox',
    align: 'stretch'
  },
  constructor: function constructor(config) {
    var me = this;
    me.callParent(arguments);
    Ext.ux.wx.LockMaskManager.register(me);
    Ext.WindowManager.lastActiveForm = me; // Logo

    me.add({
      xtype: 'panel',
      layout: 'fit',
      style: {
        backgroundColor: 'rgba(255, 255, 255, 0.6)'
      },
      items: [{
        xtype: 'component',
        autoEl: {
          tag: 'div',
          cls: Ext.baseCSSPrefix + 'login-form-logo',
          style: {
            margin: '20px',
            minWidth: '300px',
            minHeight: '300px',
            backgroundImage: me.getLogoUrl(),
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain'
          }
        }
      }]
    }); // Panel

    me.add(me.pnlInput = new Ext.form.Panel(Ext.apply({
      internalName: 'pnlInput',
      cls: Ext.baseCSSPrefix + 'splash-form-panel',
      frame: false,
      border: false,
      flex: 1,
      bodyPadding: "70px 30px 40px",
      layout: {
        type: 'vbox',
        align: 'stretch'
      }
    }, me.getInputPanelCfg())));
  },
  // Can be overrided
  getLogoUrl: function getLogoUrl() {
    if (Ext.ux.wx.ApplicationManager.backgroundLogoUrl) {
      return 'url("' + Ext.ux.wx.ApplicationManager.backgroundLogoUrl + '")';
    }

    return '';
  },
  // To be overrided
  getInputPanelCfg: function getInputPanelCfg() {
    return null;
  },
  onDestroy: function onDestroy() {
    var me = this;
    me.callParent(arguments);
    Ext.ux.wx.LockMaskManager.unregister(me);

    if (Ext.WindowManager.lastActiveForm == me) {
      Ext.WindowManager.lastActiveForm = null;
    }
  },
  //override
  beforeShow: function beforeShow() {
    var loading;
    this.callParent(arguments); // Hide all others widows and their shadow

    Ext.select('.x-window:not(.x-splash-form)').hide();
    Ext.select('.x-css-shadow').hide(); // SessionManager Admin is a window but not SessionManager User so we have to handle it

    Ext.select('.x-session-manager-user').hide(); // Hide "ProConcept is loading..." if necessary

    loading = Ext.get('loading');

    if (loading && loading.isVisible()) {
      loading.hide();
    } // // Hide left logo
    // logo = Ext.get('background-logo');
    // if (logo) {
    //     logo.hide();
    // }

  },
  //override
  afterHide: function afterHide() {
    // var logo;
    this.callParent(arguments); // Show "ProConcept is loading..."

    Ext.get('loading').show(); // // Show left logo
    // logo = Ext.get('background-logo');
    // if (logo) {
    //     logo.show();
    // }
  }
});
/**
 * @class Ext.ux.wx.SplashLoginForm
 */
Ext.define('Ext.ux.wx.SplashLoginForm', {
  extend: 'Ext.ux.wx.SplashBaseForm',
  itemId: 'frmLogin',
  internalName: 'frmLogin',
  config: {
    /**
     * @cfg {String} defaultUsername
     */
    defaultUsername: '',

    /**
     * @cfg {String} defaultPassword
     */
    defaultPassword: '',

    /**
     * @cfg {String} logoSrc
     */
    logoSrc: ''
  },
  //override
  constructor: function constructor(config) {
    var me = this;
    me.callParent(arguments);
    me.pnlLogin = me.pnlInput;
  },
  //override
  getLogoUrl: function getLogoUrl() {
    return 'url("' + this.getLogoSrc() + '")';
  },
  //override
  getInputPanelCfg: function getInputPanelCfg() {
    var me = this; // Panel

    return {
      itemId: 'pnlLogin',
      internalName: 'pnlLogin',
      // Validation par la touche ENTER
      defaults: {
        enableKeyEvents: true,
        listeners: {
          specialKey: function specialKey(field, event) {
            if (event.getKey() == event.ENTER) {
              // Problème de sécurité avec les mots de passes enregistrés par le navigateur (l'input password contient visuellement la valeur
              // mais le javascript n'y a pas accès tant que l'utilisateur n'a pas effectué d'action dans la page).
              // Le ENTER est une action qui libère l'accès à cette valeur, mais il faut qu'il soit complétement traité avant d'essayer d'y
              // accéder.
              setTimeout(function () {
                me.pnlLogin.query('#btnLogin')[0].handler.call(me.pnlLogin.query('#btnLogin')[0].scope);
              }, 1);
            }
          },
          keydown: function keydown(field, event) {
            if (event.ctrlKey && event.shiftKey && !event.altKey && event.getKey() === event.C) {
              event.preventDefault();
              window.frmChangePwd = new Ext.ux.wx.PasswordChanger({
                contextPwd: 'changePwd'
              });
              window.frmChangePwd.showWindow(me.pnlLogin.getComponent('edtName').getValue(), me.pnlLogin.getComponent('edtPwd').getValue());
            }
          }
        }
      },
      items: [{
        itemId: 'edtName',
        internalName: 'edtName',
        xtype: 'textfield',
        fieldLabel: 'Username',
        labelSeparator: '',
        labelAlign: 'top',
        allowBlank: false,
        value: me.getDefaultUsername()
      }, {
        itemId: 'edtPwd',
        internalName: 'edtPwd',
        xtype: 'textfield',
        fieldLabel: 'Password',
        labelSeparator: '',
        labelAlign: 'top',
        inputType: 'password',
        allowBlank: false,
        value: me.getDefaultPassword()
      }, // version "one button" avec ExtJS 6.5
      {
        xtype: 'tbfill'
      }, {
        itemId: 'btnLogin',
        internalName: 'btnLogin',
        xtype: 'button',
        text: 'Login',
        handler: function handler() {
          // Validation sur le client (champs obligatoires avant d'effecture la validation sur le server
          if (me.pnlLogin.getComponent('edtName').validate() && me.pnlLogin.getComponent('edtPwd').validate()) {
            Ext.ux.wx.LockMaskManager.showLockMask();
            window.doLogin(me.pnlLogin.getComponent('edtName').getValue().trim(), me.pnlLogin.getComponent('edtPwd').getValue());
          }
        }
      }]
    };
  },
  //override
  afterShow: function afterShow() {
    var me = this; // Focus dans le premier edit (delai nécessaire sinon le focus ne vient pas ou alors non sélectionné)

    me.pnlLogin.getComponent('edtName').focus(true, 100);
    me.callParent(arguments);
  }
});
/**
 * @class Ext.ux.wx.ApplicationManager
 */
Ext.define('Ext.ux.wx.ApplicationManager', {
  singleton: true,
  mixins: {
    observable: 'Ext.mixin.Observable'
  },
  transactionsCount: 0,
  wxoNamespace: '',
  generated: new Date('2022-05-06T10:14:10.756Z'),
  config: {
    /**
     * @cfg {double} companyTimeLag (Number of days, frac for time lag)
     */
    companyTimeLag: undefined,

    /**
     * @cfg {boolean} autoLockLayoutWS
     */
    autoLockLayoutWS: undefined
  },
  // override
  constructor: function constructor(config) {
    var me = this; // XSS protection https://www.sencha.com/forum/showthread.php?285956
    // Suppress when migrate to ExtJS 7
    // Warning: JSON norme must be respected in order to use native !
    // cf https://www.json.org

    if (typeof window.JSON !== 'undefined') {
      // for ie
      Ext.USE_NATIVE_JSON = true;
    }

    me.mixins.observable.constructor.call(me, config);
    wxAddEvents(
    /**
     * @event wxWindowResize
     * Fires when the size of the browser change
     * @param {Ext.ux.wx.ApplicationManager} sender
     * @param {Integer} aWindowWidth
     * @param {Integer} aWindowHeight
     */
    'wxWindowResize',
    /**
     * @event wxWindowCheckCookieExpiry
     * Fires when the cookie will be invalidated, to check if it was renewed
     * @param {Ext.ux.wx.ApplicationManager} sender
     */
    'wxWindowCheckCookieExpiry',
    /**
     * @event wxWindowUpdateCookieExpiry
     * Fires when the cookie will be invalidated, to renew the cookie expiry
     * @param {Ext.ux.wx.ApplicationManager} sender
     */
    'wxWindowUpdateCookieExpiry',
    /**
     * @event wxSkinAfterLoad
     * Fires when skin has finished loading (async)
     * @param {boolean} loaded
     */
    'wxSkinAfterLoad');
    me.callParent(arguments);
  },

  /**
   * Get a wxo object
   * @param  {string} objectName
   * @return {object} The object
   */
  getWxoObject: function getWxoObject(objectName) {
    var obj = objectName.split('.').pop();
    return this.getWxoNamespace()[obj];
  },

  /**
   * Set a wxo object
   * @param  {string} objectName
   * @param  {object} value
   * @return {object} The object
   */
  setWxoObject: function setWxoObject(objectName, value) {
    var obj = objectName.split('.').pop();
    this.getWxoNamespace()[obj] = value;
  },
  getWxoObjectFullName: function getWxoObjectFullName(key) {
    return this.getWxoNamespacePrefix() + key;
  },

  /**
   * Get the namespace name containing the wxo objects (could be window)
   * @return {object} The namespace name
   */
  getWxoNamespacePrefix: function getWxoNamespacePrefix() {
    if (!this.wxoNamespacePrefix) this.wxoNamespacePrefix = this.wxoNamespace ? this.wxoNamespace + '.' : '';
    return this.wxoNamespacePrefix;
  },

  /**
   * Get the namespace containing the wxo objects (could be window)
   * @return {object} The namespace
   */
  getWxoNamespace: function getWxoNamespace() {
    if (!this.wxoNamespaceObject) this.wxoNamespaceObject = this.wxoNamespace ? Ext.namespace(this.wxoNamespace) : window;
    return this.wxoNamespaceObject;
  },

  /**
   * initValues
   */
  initValues: function initValues() {
    var me = this;
    Ext.on('resize', me.doWindowResize); //Sous firefox, si on utilise Ext.EventManager.on sur beforeunload, la valeur de retour est ignorée
    //Pas trouvé la raison...
    //Maintenant sous Chrome aussi...

    /*EXTJS6: Ext.EventManager.on is deprecated*/
    //if (Ext.isGecko || Ext.isWebKit) {

    window.onbeforeunload = me.doBeforeUnload;
    window.onunload = me.doUnload; //} else {
    // Ext.getWin().on('onbeforeunload', me.doBeforeUnload);
    // Ext.getWin().on('unload', me.doUnload);
    // Ext.EventManager.on(window, 'beforeunload', me.doBeforeUnload, me);
    // Ext.EventManager.on(window, 'unload', me.doUnload, me);
    //}
  },
  doBeforeUnload: function doBeforeUnload(e) {
    var me = Ext.ux.wx.ApplicationManager,
        ws = Ext.ux.wx.WebSocketSingleton.ws,
        confirmationText = Ext.ux.wx.TranslateManager.getWord('txtAppConfirmClose', 'You still have work in progress. Do you really want to disconnect?');

    if (me.transactionsCount > 0 && ws.readyState == ws.OPEN) {
      me.needClose = true;
      e.returnValue = confirmationText;
      return confirmationText;
    } else {
      me.closePage();
      me.needClose = false;
    }
  },
  doUnload: function doUnload(e) {
    var me = Ext.ux.wx.ApplicationManager;

    if (me.needClose) {
      me.closePage(e);
    }
  },
  doWindowResize: function doWindowResize(e) {
    var me = Ext.ux.wx.ApplicationManager;
    me.fireEvent('wxWindowResize', me, window.documentWidth(), window.documentHeight());
  },
  closePage: function closePage(e) {
    Ext.ux.wx.WebSocketSingleton.wsShowMsgOnClose = false;
    Ext.ux.wx.WebSocketSingleton.close();
  },

  /**
   * setTransactionsCount
   * @param {Integer} value number of transactions actives
   */
  setTransactionsCount: function setTransactionsCount(value) {
    this.transactionsCount = value;
  },

  /**
   * incTransactionsCount
   */
  incTransactionsCount: function incTransactionsCount() {
    this.transactionsCount += 1;
  },

  /**
   * incTransactionsCount
   */
  decTransactionsCount: function decTransactionsCount() {
    this.transactionsCount -= 1;
  },

  /**
   * updateInfo
   * @param {string} version patchset number
   * @param {string} user user_name
   */
  updateInfo: function updateInfo(version, user) {
    this.appInfo = {
      version: version,
      user: user
    };
  },
  getInfo: function getInfo(name) {
    if (this.appInfo) return this.appInfo[name];
  },

  /**
   * initCookieInfos
   * @param {Integer} formShowDelay when the cookie extend form will appear
   * @param {Integer} formCloseDelay when the cookie extend form will close
   */
  initCookieInfos: function initCookieInfos(formShowDelay, formCloseDelay) {
    var me = this;

    if (formShowDelay <= 0 && me.cookieExtendForm && me.cookieExtendForm.isVisible()) {
      // No new expiry, we need to wait...
      me.cookieExtendForm.zIndexManager.bringToFront(me.cookieExtendForm);
      return;
    } // When we update the delay, we need to cancel previous task


    if (me.taskCookieExtendForm) {
      me.taskCookieExtendForm.cancel();

      if (me.taskCookieExtendFormClose) {
        me.taskCookieExtendFormClose.cancel();
        me.closeCookieExtendForm();
      }
    } else {
      me.taskCookieExtendForm = new Ext.util.DelayedTask(function () {
        me.showCookieExtendForm(formCloseDelay);
      });
    }

    me.taskCookieExtendForm.delay(formShowDelay < 0 ? 0 : formShowDelay);
  },
  showCookieExtendForm: function showCookieExtendForm(formCloseDelay) {
    var me = this,
        cpt = 0,
        strMsgMin = Ext.ux.wx.TranslateManager.getWord('txtAppExtendMsgMin', 'Your session will be disconnected in %d minute(s).'),
        strMsgSec = Ext.ux.wx.TranslateManager.getWord('txtAppExtendMsgSec', 'Your session will be disconnected in %d second(s).');

    if (!me.cookieExtendForm) {
      me.cookieExtendForm = new Ext.window.MessageBox({
        closeAction: 'destroy' // destroy only when we close (not when button are clicked)

      }).show({
        title: Ext.ux.wx.TranslateManager.getWord('wsLogoutTitle', 'Session logout'),
        icon: Ext.Msg.INFO,
        msg: strMsgMin.replace('%d', Math.floor(formCloseDelay / 1000 / 60 % 60)),
        buttons: Ext.Msg.YESNO,
        buttonText: {
          yes: Ext.ux.wx.TranslateManager.getWord('txtAppExtendBtn', "Extend"),
          no: Ext.ux.wx.TranslateManager.getWord('wsLogoutBtnClose', "Close")
        },
        closable: false,
        fn: function fn(buttonId) {
          if (buttonId === 'yes') me.fireEvent('wxWindowUpdateCookieExpiry', me); // no destroy, server will call initCookieInfos()
          else if (buttonId === 'no') closeWindow(); // no destroy, window will close or reload
        },
        scope: me
      });
    }

    if (!me.taskCookieExtendFormClose) {
      me.taskCookieExtendFormClose = new Ext.util.DelayedTask(function () {
        var remainSec = formCloseDelay / 1000 - cpt++,
            ws = Ext.ux.wx.WebSocketSingleton.ws; // If the websocket was closed, we close the extend form

        if (!ws || ws.readyState !== ws.OPEN) {
          me.closeCookieExtendForm();
          return;
        } // The cookie is expired, we force to close the app


        if (remainSec <= 0) {
          me.closeCookieExtendForm();
          Ext.ux.wx.WebSocketSingleton.wsShowMsgOnClose = true;
          Ext.ux.wx.WebSocketSingleton.close('logout');
          return;
        } // Otherwise we show the extend form with remaining time


        if (remainSec >= 60) {
          me.cookieExtendForm.msg.setHtml(strMsgMin.replace('%d', Math.floor(remainSec / 60 % 60)));
        } else {
          me.cookieExtendForm.msg.setHtml(strMsgSec.replace('%d', remainSec));
        }

        if (cpt % 5 == 0) {
          me.fireEvent('wxWindowCheckCookieExpiry', me);
        }

        me.taskCookieExtendFormClose.delay(1000);
      });
    }

    me.taskCookieExtendFormClose.delay(1000);
  },

  closeCookieExtendForm() {
    const me = this;

    if (me.cookieExtendForm) {
      // close() call fn with btnId = 'cancel' then destroy() (see closeAction)
      me.cookieExtendForm.close(); // Alternative:
      // me.cookieExtendForm.hide();
      // me.cookieExtendForm.destroy();

      me.cookieExtendForm = undefined;
    }
  },

  updateAutoLockLayoutWS: function updateAutoLockLayoutWS(newValue, oldValue) {
    if (newValue) Ext.suspendLayouts();else Ext.resumeLayouts(true);
  },
  asyncLoad: function asyncLoad(files) {
    return Promise.all(files.map(f => new Promise((resolve, reject) => {
      const element = document.createElement(f.tag);
      let parent = f.parent || 'head',
          attr = 'src'; // Important success and error for the promise

      element.onload = event => {
        f.element = event.target;
        resolve(f);
      };

      element.onerror = () => {
        reject(f);
      }; // Need to set different attributes depending on tag type


      switch (f.tag) {
        case 'script':
          element.async = true;
          break;

        case 'link':
          element.type = 'text/css';
          element.rel = 'stylesheet';
          element.title = f.title;
          attr = 'href';
      } // Inject into document to kick off loading


      element[attr] = f.href;
      if (f.before) document[parent].insertBefore(element, f.before);else document[parent].appendChild(element);
    })));
  },

  /**
   * Select skin
   * @param {string} skin
   */
  wxSelectSkin: async function wxSelectSkin(skin) {
    let loaded;

    try {
      loaded = await skinController.select(skin);
    } finally {
      this.fireEvent('wxSkinAfterLoad', loaded);
    }
  }
});
/**
 * @class Ext.ux.wx.DebugManager
 * This class is used in debugMode to send error to server
 * but also in releaseMode to display error to user
 */
Ext.define('Ext.ux.wx.DebugManager', {
  TXT_DEBUGJS: 'Add &DEBUGJS=1 to url to enhance debugging',
  singleton: true,

  /**
   * Max width in char of the report (use to concatenate symbole +)
   * @type {Number}
   */
  reportWidth: 79,
  activeDebugMode: function activeDebugMode() {
    window.location.search += '&DEBUGJS=1';
  },

  /**
   * Check if debug is active
   * @return {Boolean} true if debug active
   */
  isDebugActive: function isDebugActive() {
    return this.isDebugMode;
  },

  /**
   * Start the debug
   * @param {boolean} isDebugMode
   */
  startDebug: function startDebug(isDebugMode, isLoginForm) {
    this.isDebugMode = isDebugMode;
    this.isLoginForm = isLoginForm;
    Ext.ux.wx.DebugLogs.on(isDebugMode ? 'all' : 'error');
    Ext.ux.wx.DebugLogs.onErrorHandler = this.onErrorHandler;

    if (!isDebugMode) {
      // Les méthode Ext.log.* sont déasctivées en mode release
      // Utilisé par layout notamment, du coup pas d'erreur nulle part, mais ça fct pas.
      if (Ext.log.warn === Ext.emptyFn) Ext.log.warn = Ext.ux.wx.DebugLogs.consoles.both.warn;
      if (Ext.log.error === Ext.emptyFn) Ext.log.error = Ext.ux.wx.DebugLogs.consoles.both.error;
    } else if (Error && Error.stackTraceLimit && Error.stackTraceLimit === 10) Error.stackTraceLimit = 100; // perhaps slow down => so only in debugMode
    // Afficher la modale d'erreur


    Ext.Error.handle = this.extErrorHandler;
  },

  /**
   * Stop the debug
   */
  stopDebug: function stopDebug() {
    // window.onerror = this.originalDebug;
    // if (window.debuglogs)
    Ext.ux.wx.DebugLogs.off();
  },
  asyncSendMask: function asyncSendMask(error, data, win) {
    win.mask(Ext.ux.wx.TranslateManager.getWord('txtAppLockMask', 'Please wait...'));
    Ext.ux.wx.DebugManager.asyncSend({
      error: error,
      data: data
    }, () => win.unmask());
  },

  /**
   * Send the debug data to the server using a POST or save to client
   */
  asyncSend: function asyncSend(debug, cb) {
    var me = this;
    me.getAsyncLogData(debug).then(data => me.internalSendDebugReport(data, cb));
  },
  internalSendDebugReport: function internalSendDebugReport(debugData, cb) {
    var me = this,
        debugFile,
        download = true;
    debugFile = {
      blob: new Blob([debugData], {
        type: 'text/plain'
      }),
      filename: 'debuglog.log'
    }; // if (Ext.isGecko || !window.html2canvas) {

    me.sendFiles(debugFile, undefined, download, cb); // Ne fct plus...à revoir
    // } else {
    //     html2canvas(document.body).then(function(canvas) {
    //         canvas.toBlob(function (blob) {
    //             me.sendFiles(debugFile, {blob: blob, filename: 'debugimage.jpg'}, download, cb);
    //         });
    //     });
    // }
  },
  // private
  sendFiles: function sendFiles(debugFile, imageFile, download, cb) {
    if (download) this.saveFiles(debugFile, imageFile);

    if (!this.isLoginForm) {
      this.postFiles(debugFile, imageFile);
    }

    if (cb) cb();
  },

  /**
   * POST data to the server
   * @private
   */
  postFiles: function postFiles(debugFile, imageFile) {
    var formData = new FormData();
    if (imageFile) formData.append("debugimage", imageFile.blob, imageFile.filename);
    formData.append("debuglog", debugFile.blob, debugFile.filename);
    Ext.ux.wx.Uploader.uploadFiles({
      rawData: formData,
      url: "AfterUpload?DIALOG_KEY=DEBUGJS&INS_KEY=" + Ext.urlDecode(window.location.search).InsKey,
      method: "POST",
      success: function success(response, opt) {
        console.log("Debug log correctly transfered!");
      },
      failure: function failure(response, opt) {
        console.log("Error when transfering Debug log!");
        alert("Error when transfering Debug log!");
      }
    });
  },
  // private
  saveFiles: function saveFiles(debugFile, imageFile) {
    // cf. fileSaver.js
    if (window.saveAs) {
      saveAs(debugFile.blob, debugFile.filename);
      if (imageFile) saveAs(imageFile.blob, imageFile.filename);
    }
  },

  /**
   * Return a string containing all the wxo Object with their name and class
   */
  getWxoListData: function getWxoListData() {
    var output = [],
        namespace = Ext.ux.wx.ApplicationManager.getWxoNamespace(),
        useNamespace = namespace !== window,
        obj;
    output.push(this.getSectionSeparator("Objects list", true));
    if (namespace) Object.keys(namespace).forEach(key => {
      obj = namespace[key];
      if (obj && (useNamespace || key.search(/^O\d+$/) > -1)) // if window => keep only Odddd objects
        output.push((obj.nm || Ext.ux.wx.ApplicationManager.getWxoObjectFullName(key)) + ' =\t' + obj.internalName + ' / ' + obj.id + ' (' + (obj.internalClassName || obj.$className) + this.getObjDebugInfo(obj) + ')' + (obj.destroyed ? ' destroyed' : ''));
    });
    output.push(this.getSectionSeparator());
    return output.join('\n');
  },
  getObjDebugInfo: function getObjDebugInfo(obj) {
    var owner = obj.getRefOwner && obj.getRefOwner(),
        name = owner ? owner.nm || owner.id : '',
        info = obj.getWxDebugInfo && obj.getWxDebugInfo();
    if (name) info = Ext.apply(info || {}, {
      owner: name
    });
    if (info) return ', ' + Object.keys(info).map(k => k + ': ' + info[k]).join(', ');
    return '';
  },
  getComponentListData: function getComponentListData() {
    var output = [],
        components = Ext.ComponentManager.all,
        obj;
    output.push(this.getSectionSeparator("Components list", true));
    if (components) Object.keys(components).forEach(key => {
      obj = components[key];
      if (obj && !obj.nm) // log only object without nm (object created by delphi see above)
        output.push(obj.id + ' = ' + obj.$className + this.getObjDebugInfo(obj) + (obj.destroyed ? ' destroyed' : ''));
    });
    output.push(this.getSectionSeparator());
    return output.join('\n');
  },
  getListFloatingSyncHidden: function getListFloatingSyncHidden() {
    var event,
        obj,
        output = [];

    if (Ext.GlobalEvents.events && Ext.GlobalEvents.events.show) {
      event = Ext.GlobalEvents.events.show;

      if (event.listeners) {
        output.push(this.getSectionSeparator("Floating SyncHidden list", true));
        event.listeners.forEach(listener => {
          if (listener.scope && listener.fn === 'syncHidden') {
            obj = listener.scope;
            output.push(obj.id + ' (' + obj.$className + ')' + ' ' + obj.nm + (obj.destroyed ? ' destroyed' : ''));
            obj = obj.ownerCt || obj.floatParent;
            if (obj) output.push('\t Parent: ' + obj.id + ' (' + obj.$className + ')' + ' ' + obj.nm + (obj.destroyed ? ' destroyed' : ''));
          }
        });
        output.push(this.getSectionSeparator());
        return output.join('\n');
      }
    }

    return '';
  },

  /**
   * Return a string containing last layout data
   */
  getLayoutListData: function getLayoutListData() {
    var output = [],
        element;
    if (!this.isDebugActive()) return '';
    output.push(this.getSectionSeparator("Layout", true));

    for (var index = 0; index < Ext.ux.wx.DebugLogs.layouts.length; index++) {
      element = Ext.ux.wx.DebugLogs.layouts[index];
      output.push(element.trace + '\n');

      for (var index2 = 0; index2 < element.items.length; index2++) output.push('class: ' + element.items[index2].class + ' / nm: ' + element.items[index2].name + '\n');

      output.push('\n');
    }

    output.push(this.getSectionSeparator());
    return output.join("\n");
  },

  /**
   * Return a string containing the navigator information (version, url, ...)
   */
  getNavigatorData: function getNavigatorData() {
    var output = [];
    output.push(this.getSectionSeparator("Navigator", true));
    output.push('Name: ' + Ext.browser.name);
    output.push('Version: ' + (Ext.browser.version ? Ext.browser.version.version : ''));
    output.push('EngineName: ' + Ext.browser.engineName);
    output.push("UserAgent: " + navigator.userAgent);
    output.push("Language: " + navigator.language);
    output.push("Platform: " + navigator.platform);
    output.push("URL: " + document.URL);
    output.push("cookie: " + document.cookie);
    output.push("debugMode: " + (Ext.ux.wx.DebugManager.isDebugActive() ? 'true' : 'false'));
    output.push("lockLayout: " + Ext.ux.wx.ApplicationManager.getAutoLockLayoutWS());
    output.push("theme: " + (skinController && skinController.skin));
    output.push("Generated date: " + Ext.Date.format(Ext.ux.wx.ApplicationManager.generated, 'd/m/Y H:i:s'));
    output.push("PCS Version: " + Ext.ux.wx.ApplicationManager.getInfo('version'));
    output.push("User: " + Ext.ux.wx.ApplicationManager.getInfo('user'));
    output.push(this.getSectionSeparator());
    return output.join("\n");
  },

  /**
   * Return a string containing the debug log from the console
   */
  getConsoleLogData: function getConsoleLogData() {
    var output = Ext.ux.wx.DebugLogs.output;

    if (output && output !== '') {
      return this.getSectionSeparator("Console log", true) + '\n' + output + '\n' + this.getSectionSeparator();
    }

    return '';
  },
  getComData: function getComData() {
    var output = Ext.ux.wx.DebugLogs.comData;

    if (output && output !== '') {
      return this.getSectionSeparator("Communication data", true) + '\n' + output + '\n' + this.getSectionSeparator();
    }

    return '';
  },
  getAsynchStackTraceData: function getAsynchStackTraceData(error) {
    var me = this;
    return new Promise(function (resolve, reject) {
      Ext.ux.wx.DebugManager.getAsyncStackTrace(error).then(value => {
        resolve(me.getSectionSeparator("StackTrace (sourceMap)", true) + '\n' + value + '\n' + me.getSectionSeparator());
      }).catch(err => {
        resolve(me.getSectionSeparator("StackTrace (sourceMap)", true) + '\n' + err + '\n' + me.getSectionSeparator());
      });
    });
  },
  getErrorData: function getErrorData(error) {
    var output = [];

    if (error) {
      output.push(this.getSectionSeparator("Error log", true));
      output.push('Error: ' + error.message);
      if (error.lineNumber) output.push('Line: ' + error.lineNumber);
      if (error.columnNumber) output.push('Column: ' + error.columnNumber);
      output.push('Call stack:\n' + error.stack);
      output.push(this.getSectionSeparator());
    }

    return output.join("\n");
  },
  getReceivedData: function getReceivedData(data) {
    var output = [];

    if (data) {
      output.push(this.getSectionSeparator("Data", true));
      output.push(data);
      output.push(this.getSectionSeparator());
    }

    return output.join("\n");
  },
  getSectionSeparator: function getSectionSeparator(description, start) {
    var output = "";

    if (start) {
      if (description) {
        output = "--- " + description + " ";
        output += "-".repeat(this.reportWidth - output.length);
      } else {
        output = "-".repeat(this.reportWidth);
      }
    } else output = "-".repeat(this.reportWidth) + '\n';

    return output;
  },

  /**
   * Return a string containing the concatenation of the debug datas
   */
  getAsyncLogData: function getAsyncLogData(debug) {
    var me = this,
        output = [],
        today = new Date();
    return new Promise((resolve, reject) => {
      output.push(me.getSectionSeparator(null, true));
      output.push(me.getSectionSeparator("Report " + today.toString(), true));
      output.push(me.getSectionSeparator());
      output.push(me.getNavigatorData());
      output.push(me.getErrorData(debug && debug.error));
      me.getAsynchStackTraceData(debug && debug.error).then(stackTrace => {
        output.push(stackTrace);
        output.push(me.getReceivedData(debug && debug.data));
        output.push(me.getWxoListData());
        output.push(me.getComponentListData());
        output.push(me.getListFloatingSyncHidden());
        output.push(me.getConsoleLogData());
        output.push(me.getComData());
        output.push(me.getLayoutListData());
        return resolve(output.join("\n"));
      });
    });
  },
  extErrorHandler: function extErrorHandler(err) {
    try {
      throw new Ext.Error(err);
    } catch (ex) {
      Ext.log.error(ex.toString());
      ex.wxError = true; // cf. Ext.ux.wx.overrides.XTemplate#applyOut
      // Ext.ux.wx.DebugManager.errorHandler(ex);

      throw ex; // window.onError => Ext.ux.wx.DebugManager.errorHandler (sauf si y a un catch !)
    }
  },
  onErrorHandler: function onErrorHandler(errorMsg, url, line, column, stack) {
    var me = Ext.ux.wx.DebugManager,
        // this = windows
    consoleOnly = false; // TODO voir si on affiche toutes les erreurs ou seulement dans la console ?

    me.errorHandler.apply(me, [{
      message: errorMsg,
      fileName: url,
      lineNumber: line,
      columnNumber: column,
      stack: stack
    }, undefined, consoleOnly]);
  },
  // called directly (cf. WebSocketSingleton) or from onErrorHandler
  errorHandler: function errorHandler(error, data, consoleOnly) {
    // Firefox
    if (error.stack && error.stack.message) error.message = error.stack.message;
    if (error.stack && error.stack.stack) error.stack = error.stack.stack; // in Chrome stack is in property error.stack.stack when call from try...catch

    if (error.message) error.message = error.message.replace('Uncaught', '').trim();else error.message = 'Unknown error';

    if (!consoleOnly && !this.debugWnd) {
      // N'afficher que la 1ère form le reste est dans la console et dans le rapport de bugs...
      // If called during global layout suspension, display a special error form
      // Otherwise form is not displayed or partial (but not readable)
      if (!Ext.Component.layoutSuspendCount && !Ext.Component.runningLayoutContext && !this.isLoginForm) {
        if (Ext.ux.wx.debugJS) {
          this.showMsgSource(error, data);
        } else {
          this.showMsgErr(error, data);
        }
      } else {
        this.showMsgErrNoLayout(error, data);
      }
    } // else uniquement dans la console (+ évt dans un fichier via "Envoyer un rapport de bug"...)

  },
  getAsyncStackTrace: function getAsyncStackTrace(error) {
    var options = {
      /* reprise de la fonction _xdr avec ajout du header PCS */
      ajax: function ajax(url) {
        return new Promise(function (resolve, reject) {
          var req = new XMLHttpRequest();
          req.open('get', url);
          /* MOD PCS: ajout du header pour filtrer avec apache */

          req.setRequestHeader('X-Requested-By', 'DebugManager');
          /* END MOD */

          req.onerror = reject;

          req.onreadystatechange = function onreadystatechange() {
            if (req.readyState === 4) {
              if (req.status >= 200 && req.status < 300 || url.substr(0, 7) === 'file://' && req.responseText) {
                resolve(req.responseText);
              } else {
                reject(new Error('HTTP status: ' + req.status + ' retrieving ' + url));
              }
            }
          };

          req.send();
        });
      }
    };
    return new Promise(function (resolve, reject) {
      if (StackTrace && error) StackTrace.fromError(error, options).then(values => {
        resolve(values.map(sf => sf.toString()).join('\n'));
      }).catch(err => resolve(err));else // no stackTrace
        resolve('');
    });
  },

  getMsgHeader(title, fn) {
    return {
      titlePosition: 0,
      listeners: {
        click: function click(header, e) {
          if (e.target && e.target.getAttribute("data-internalname") === 'debugLink') {
            fn(arguments);
            return false;
          }
        }
      },
      items: [{
        internalName: 'debugLink',
        xtype: 'box',
        autoEl: {
          tag: 'a',
          // href: '#',  // add the caracter # in url
          html: title,
          cls: 'x-custom-link' // to simulate link without href

        },
        align: 'right',
        margin: 2
      }]
    };
  },

  getMsgErrorCfg(error) {
    return {
      title: Ext.ux.wx.TranslateManager.getWord('errTitle', 'Error occured'),
      msg: Ext.ux.wx.TranslateManager.getWord('errMsg', 'The application has encountered a problem. We are sorry for the inconvenience.') + '<BR><BR>' + Ext.htmlEncode(error.message) + '<BR><BR>' + Ext.ux.wx.TranslateManager.getWord('errSendDebugInfo', 'Help us improve by sending bug report.'),
      buttonText: {
        ok: Ext.ux.wx.TranslateManager.getWord('DebugInfo', 'Bug report'),
        cancel: Ext.ux.wx.TranslateManager.getWord('OK')
      }
    };
  },

  showMsgErrNoLayout: function showMsgErrNoLayout(error, data) {
    var me = this;
    me.debugWnd = new Ext.ux.wx.ErrorForm(Ext.apply({
      listeners: {
        bugReport: function bugReport() {
          me.asyncSendMask(error, data, me.debugWnd);
        },
        close: function close() {
          Ext.ux.wx.DebugManager.debugWnd.destroy();
          delete Ext.ux.wx.DebugManager.debugWnd; // force refresh after layout error

          window.location.search += '';
        }
      }
    }, me.getMsgErrorCfg(error)));
  },
  showMsgErr: function showMsgErr(error, data) {
    var me = this;
    me.debugWnd = new Ext.window.MessageBox({
      header: me.getMsgHeader(Ext.ux.wx.TranslateManager.getWord('ShowDebugInfos', 'Technical details'), () => {
        me.debugWnd.close(); // call fn('cancel') below

        Ext.ux.wx.DebugManager.showMsgSource(error, data);
      }),
      listeners: {
        beforeHide: () => {
          if (!me.debugWnd.wxAllowHide) return false;
        },
        beforeClose: () => {
          me.debugWnd.wxAllowHide = true;
        }
      }
    }).show(Ext.apply({
      icon: Ext.Msg.ERROR,
      buttons: Ext.Msg.OKCANCEL,
      isDebugWnd: true,
      alwaysOnTop: true,
      fn: function fn(buttonValue, inputText, showConfig) {
        if (buttonValue === 'ok') // text = report
          Ext.ux.wx.DebugManager.asyncSendMask(error, data, Ext.ux.wx.DebugManager.debugWnd);else {
          // if (buttonValue === 'cancel') // text = ok
          me.debugWnd.wxAllowHide = true;
          me.debugWnd.hide(); // not close() => loop !

          me.debugWnd.destroy();
          delete me.debugWnd;
        }
      },
      scope: this
    }, this.getMsgErrorCfg(error)));
  },
  showMsgSource: function showMsgSource(error, data) {
    var title = '',
        callStack = '',
        position = '',
        fileName;
    if (error.message) title = Ext.htmlEncode(error.message);else title = ''; // Dans chrome, il n'y a pas de fileName, line ou column dans le cas d'un try...catch(error), on affiche juste le callStack
    // (évt. voir https://github.com/stacktracejs/error-stack-parser)
    // Ces infos sont uniquement disponibles dans FireFox (Si l'erreur provient de ExtJS, lineNumber et columnNumber sont à 0)

    position = (error.lineNumber ? 'line: ' + error.lineNumber : '') + (error.columnNumber ? ', column: ' + error.columnNumber : '');
    if (position) position = '(' + position + ')';
    title = error.message;

    if (error.fileName) {
      fileName = error.fileName.replace(window.location.protocol + '//' + window.location.host, ''); // S'il s'agit du fichier pce.wcl.executeJS ne pas afficher de callstack

      if (error.fileName !== window.location.href && fileName && !fileName.match(/.*pce.wcl.executeJS.*\.js/i)) {
        title = title + ' in file ' + fileName;
        callStack = '\n\n/**********\n\nCall stack\n\n' + error.stack + '\n\n**********/';
      }
    } else if (error.stack) callStack = '\n\n/**********\n\nCall stack\n\n' + error.stack + '\n\n**********/';

    this.debugWnd = new Ext.window.Window({
      title: title + ' ' + position + (!position && !callStack ? 'Use Firefox or Chrome to debug' : ''),
      width: 800,
      height: 600,
      maximizable: true,
      modal: true,
      isDebugWnd: true,
      alwaysOnTop: true,
      // layout:'fit',
      layout: 'border',
      header: this.getMsgHeader(Ext.ux.wx.TranslateManager.getWord('SendDebugInfo'), () => {
        Ext.ux.wx.DebugManager.asyncSendMask(error, data, Ext.ux.wx.DebugManager.debugWnd);
      }),
      items: [// new Ext.ux.form.field.CodeMirror({
      new Ext.ux.wx.FieldSyntaxMemo({
        syntax: 'JS',
        readOnly: true,
        region: 'center',
        value: (data ? data : '') + '\n\n/*' + error.message + ' ' + position + '*/' + callStack,
        enableFind: true,
        enableReplace: true,
        enableGoToLine: true,
        itemId: 'syntaxMemoError'
      }), {
        hidden: Ext.ux.wx.debugJS,
        internalName: 'debugUrl',
        xtype: 'wxlabel',
        region: 'south',
        text: Ext.ux.wx.DebugManager.TXT_DEBUGJS,
        isHyperlink: true,
        listeners: {
          click: function click() {
            Ext.ux.wx.DebugManager.activeDebugMode();
          }
        }
      }],

      updateStackTrace(stackTrace) {
        var cmp = this.getComponent('syntaxMemoError');
        if (cmp) cmp.setValue(cmp.getValue() + '\n\n/**********\n\nStackTrace (sourceMap)\n\n' + stackTrace + '\n\n**********/');
      },

      listeners: {
        show: function show() {
          var me = this;

          if (me.x < 0 || me.y < 0) {
            me.setPosition(Math.max(0, me.x), Math.max(0, me.y));
          }

          Ext.ux.wx.DebugManager.getAsyncStackTrace(error).then(value => {
            error.stackTrace = value;
            me.updateStackTrace(value);
          }).catch(value => {
            error.stackTrace = value;
            me.updateStackTrace(value);
          });
        },
        close: function close() {
          delete Ext.ux.wx.DebugManager.debugWnd;
        }
      }
    }).show();
  }
}); // Reprise partielle de https://github.com/seriyvolk83/logs2indexeddb
// Gestion des erreurs dans la console et via window.onError

Ext.define('Ext.ux.wx.DebugLogs', {
  singleton: true,
  output: '',
  comData: '',
  onErrorHandler: Ext.emptyFn,
  debugLayout: Ext.emptyFn,
  writeComData: Ext.emptyFn,
  getStackTrace: function getStackTrace() {
    var obj = {};

    if (Error.captureStackTrace) {
      Error.captureStackTrace(obj, Ext.ux.wx.DebugLogs.getStackTrace);
      if (obj.stack) return obj.stack.replace(/^Error\n/, 'CallStack\n');
    }

    return obj.stack;
  },
  logLayout: function logLayout(context) {
    var me = Ext.ux.wx.DebugLogs,
        key,
        item,
        layout; // only in debugMode to not slow-down...

    if (context && context.items) {
      layout = {
        items: []
      };

      for (key in context.items) {
        if (context.items.hasOwnProperty(key)) {
          item = context.items[key];
          if (item.target && item.target.$className !== 'Ext.tip.QuickTip') layout.items.push({
            class: item.target.$className,
            name: item.target.nm
          });
        }
      }

      if (layout.items.length) {
        layout.trace = me.getStackTrace(); // Savegarde des 10 derniers

        if (me.layouts.length > 9) me.layouts.shift();
        me.layouts.push(layout);
      }
    }
  },
  on: function on(mode) {
    var me = Ext.ux.wx.DebugLogs;
    me.output = '';
    me.comData = '';
    me.layouts = [];

    if (mode === 'all') {
      // mode debug
      me.debugLayout = me.logLayout;

      me.writeComData = (prefix, str) => console.log(prefix + ' : ' + str);
    } else // mode release
      me.writeComData = (prefix, str) => {
        me.comData += new Date().toISOString() + ' ' + prefix.substring(0, 1) + ': ' + str + '\n';
        me.comData = me.comData.slice(-5000); // On ne garde que les derniers caractères envoyés/reçus en mode release
      };

    if ((!mode || mode === 'all' || mode === 'consoles' || mode === 'error') && me.consoles.originalIsOn === false) {
      // console = me.consoles.both;
      console.error = me.consoles.both.error;

      if (mode !== 'error') {
        console.log = me.consoles.both.log;
        console.warn = me.consoles.both.warn;
        console.info = me.consoles.both.info;
        console.debug = me.consoles.both.debug;
      }

      me.consoles.originalIsOn = true;
    }

    if ((!mode || mode === 'all' || mode === 'onerror' || mode === 'error') && me.onerror.originalIsOn === false) {
      window.onerror = me.onerror.both;
      me.onerror.originalIsOn = true;
    }
  },
  off: function off() {
    var me = Ext.ux.wx.DebugLogs;

    if (me.consoles.originalIsOn === true) {
      // console = me.consoles.original;
      console.log = me.consoles.original.log;
      console.warn = me.consoles.original.warn;
      console.error = me.consoles.original.error;
      console.info = me.consoles.original.info;
      console.debug = me.consoles.original.debug;
      me.consoles.originalIsOn = false;
    }

    if (me.onerror.originalIsOn === true) {
      window.onerror = me.onerror.original;
      me.onerror.originalIsOn = false;
    }
  },
  writelog: function writelog(label, str) {
    Ext.ux.wx.DebugLogs.output += new Date().toISOString() + "(" + label + ") " + str + "\n";
  },
  consoles: {
    originalIsOn: false,

    /**
     * @private Original console logger.
     */
    original: {
      log: console.log,
      warn: console.warn,
      error: console.error,
      info: console.info,
      debug: console.debug
    },

    /**
     * @private Logs into both - console and output
     */
    both: {
      log: function log(str) {
        Ext.ux.wx.DebugLogs.consoles.original.log.apply(console, arguments);
        Ext.ux.wx.DebugLogs.writelog('log', str);
      },
      warn: function warn(str) {
        Ext.ux.wx.DebugLogs.consoles.original.warn.apply(console, arguments);
        Ext.ux.wx.DebugLogs.writelog('warn', str);
      },

      /* MOD PCS: Desactivate
          * cause: trace has no string argument, it's used to print stackTrace in console
          *        cannot be saved in a string or elsewhere
          */
      // trace: function() {
      //         Ext.ux.wx.DebugLogs.consoles.original.trace();
      //         // Ext.ux.wx.DebugLogs.writelog('trace', str);
      // },

      /*END MOD*/
      error: function error(str) {
        Ext.ux.wx.DebugLogs.consoles.original.error.apply(console, arguments);
        Ext.ux.wx.DebugLogs.writelog('error', str);
      },
      info: function info(str) {
        Ext.ux.wx.DebugLogs.consoles.original.info.apply(console, arguments);
        Ext.ux.wx.DebugLogs.writelog('info', str);
      },
      debug: function debug(str) {
        Ext.ux.wx.DebugLogs.consoles.original.debug.apply(console, arguments);
        Ext.ux.wx.DebugLogs.writelog('debug', str);
      }
    }
  },
  onerror: {
    originalIsOn: false,

    /**
     * @private Original window.onerror
     */
    original: window.onerror,

    /**
     * Logs exception into output and call original window.onerror
     */

    /*MOD : Add other arguments (column, stack), format errorMsg
        *         not all browser transmit the last parameter
        *         => https://blog.sentry.io/2016/01/04/client-javascript-reporting-window-onerror.html
        */
    both: function both(errorMsg, url, line, column, stack) {
      var me = Ext.ux.wx.DebugLogs,
          msg = {
        error: errorMsg,
        url: url,
        line: line,
        col: column,
        stack: stack
      };
      me.writelog('error', JSON.stringify(msg));

      if (me.onErrorHandler) {
        me.onErrorHandler.apply(this, arguments);
      }

      if (me.onerror.original) {
        me.onerror.original.apply(this, arguments);
      }
    }
  }
});
// Cette classe n'est pas extraite par le wrapper
Ext.define('Ext.ux.wx.PasswordChanger', {
  extend: 'Ext.window.Window',
  title: 'Update User Password',
  bodyPadding: 20,
  closeAction: 'destroy',
  modal: true,
  config: {
    contextPwd: 'changePwd' // contextPwd: 'expiredPwd'

  },
  items: [{
    itemId: 'edtName',
    xtype: 'textfield',
    fieldLabel: 'User',
    allowBlank: false,
    value: ''
  }, {
    itemId: 'edtOldPwd',
    xtype: 'textfield',
    fieldLabel: 'Old Password',
    inputType: 'password',
    allowBlank: false,
    value: ''
  }, {
    itemId: 'edtNewPwd',
    xtype: 'textfield',
    fieldLabel: 'New Password',
    inputType: 'password',
    allowBlank: false,
    value: ''
  }, {
    itemId: 'edtConfirmPwd',
    xtype: 'textfield',
    fieldLabel: 'Confirm Password',
    inputType: 'password',
    allowBlank: false,
    value: ''
  }],
  buttons: [{
    itemId: 'btnOk',
    text: 'Ok',
    handler: function handler() {
      var me = this.up('window'),
          params; // Validation sur le client (champs obligatoires) avant d'effectuer la validation sur le server

      if (me.getComponent('edtName').validate() && me.getComponent('edtOldPwd').validate() && me.getComponent('edtNewPwd').validate() && me.getComponent('edtConfirmPwd').validate()) {
        if (me.getComponent('edtNewPwd').value.toUpperCase() !== me.getComponent('edtConfirmPwd').value.toUpperCase()) {
          Ext.Msg.show({
            title: 'Password update',
            msg: 'Confirmed password is not equal to new password',
            buttons: Ext.Msg.OK,
            icon: Ext.window.MessageBox.ERROR
          });
        } else {
          Ext.ux.wx.LockMaskManager.showLockMask();
          params = 'PathInfo=' + me.getContextPwd() + '&Ctx=&Usr=' + me.getComponent('edtName').value + '&Pwd=' + me.getComponent('edtOldPwd').value + '&NewPwd=' + me.getComponent('edtNewPwd').value;
          if (me.otherParams) params = params + '&' + me.otherParams;
          sendMsg(params);
        }
      }
    }
  }, {
    itemId: 'btnCancel',
    text: 'Cancel',
    handler: function handler() {
      var me = this.up('window');
      me.close();
    }
  }],
  // Validation par la touche ENTER
  defaults: {
    enableKeyEvents: true,
    labelWidth: 120,
    listeners: {
      specialKey: function specialKey(field, el) {
        var me = this.up('window');

        if (el.getKey() == Ext.event.Event.ENTER) {
          me.query('#btnOk')[0].handler.call(me.query('#btnOk')[0].scope || me.query('#btnOk')[0]);
        } else if (el.getKey() == Ext.event.Event.ESC) {
          me.query('#btnCancel')[0].handler.call(me.query('#btnCancel')[0].scope || me.query('#btnCancel')[0]);
        }
      }
    }
  },
  constructor: function constructor(config) {
    this.callParent(arguments);
    Ext.ux.wx.LockMaskManager.register(this);
  },
  onDestroy: function onDestroy() {
    this.callParent(arguments);
    Ext.ux.wx.LockMaskManager.unregister(this);
  },
  showWindow: function showWindow(username, password) {
    var me = this;
    me.getComponent('edtName').setValue(username);
    me.getComponent('edtOldPwd').setValue(password);
    me.show();
  }
});
/**
 * @class Ext.ux.wx.ErrorForm
 */
Ext.define('Ext.ux.wx.ErrorForm', {
  extend: 'Ext.Container',
  alwaysOnTop: true,
  baseCls: Ext.baseCSSPrefix + 'window',
  modal: true,
  floating: true,
  focusOnToFront: true,
  // No layout (use this form to show error when layout failed !)
  skipLayout: true,
  isDebugWnd: true,
  shadow: false,
  renderTpl: ['<div style="padding: 10px;">', '<div class="title" id="{id}-titleEl" data-ref="titleEl" style="font-weight: bold;">{title}</div>', '<div style="padding: 10px 0;">', '<div class="x-component x-message-box-icon x-box-item x-component-default x-dlg-icon x-message-box-error" style="left: inherit; top: inherit;"></div>', '<div id="{id}-descEl" data-ref="descEl" style="margin-left: 40px">{desc}</div>', '</div>', '<div style="margin-left: 40px">', '<button id="{id}-btnBugEl" data-ref="btnBugEl" class="x-btn x-btn-small x-btn-default-small x-btn-inner-default-small" style="width: 100px; padding: 4px; margin-right: 10px;">{ok}</button>', '<button id="{id}-btnOkEl"  data-ref="btnOkEl"  class="x-btn x-btn-small x-btn-default-small x-btn-inner-default-small" style="width: 100px; padding: 4px;">{cancel}</button>', '</div>', '</div>'],
  childEls: ['titleEl', 'descEl', 'btnBugEl', 'btnOkEl'],
  overBtnCls: Ext.baseCSSPrefix + 'btn-over',
  pressedBtnCls: Ext.baseCSSPrefix + 'btn-pressed',
  constructor: function constructor(config) {
    var me = this; // config.renderTo = Ext.getBody();

    me.renderTo = Ext.getBody();
    me.callParent(arguments);
  },
  initEvents: function initEvents() {
    var me = this;
    me.callParent(arguments);
    me.el.setLeft('20%');
    me.el.setTop('20%');

    if (me.btnBugEl) {
      me.btnBugEl.hover(me.addBtnOverCls, me.removeBtnOverCls, me);
      me.btnBugEl.on('mousedown', me.onBtnMouseDown, me);
      me.btnBugEl.on('mouseup', me.onBtnMouseUp, me);
      me.btnBugEl.on('click', me.onBtnClick, me);
    }

    if (me.btnOkEl) {
      me.btnOkEl.hover(me.addBtnOverCls, me.removeBtnOverCls, me);
      me.btnOkEl.on('mousedown', me.onBtnMouseDown, me);
      me.btnOkEl.on('mouseup', me.onBtnMouseUp, me);
      me.btnOkEl.on('click', me.onBtnClick, me);
    }
  },
  beforeRender: function beforeRender() {
    var me = this;
    me.callParent(arguments);
    Ext.applyIf(me.renderData, {
      title: me.title || 'Error',
      desc: me.msg || 'Something went wrong',
      ok: me.buttonText ? me.buttonText.ok : 'OK',
      cancel: me.buttonText ? me.buttonText.cancel : 'Cancel'
    });
  },
  addBtnOverCls: function addBtnOverCls(evt, target) {
    var el = Ext.fly(target);
    el.addCls(this.overBtnCls);
  },
  removeBtnOverCls: function removeBtnOverCls(evt, target) {
    var el = Ext.fly(target);
    el.removeCls(this.overBtnCls);
  },
  onBtnMouseDown: function onBtnMouseDown(evt, target) {
    var el = Ext.fly(target);
    el.addCls(this.pressedBtnCls);
  },
  onBtnMouseUp: function onBtnMouseUp(evt, target) {
    var el = Ext.fly(target);
    el.removeCls(this.pressedBtnCls);
  },
  onBtnClick: function onBtnClick(evt, target) {
    var me = this,
        el = Ext.fly(target);

    if (el === me.btnOkEl) {
      me.hide();
      me.fireEvent('close', me);
    } else if (el === me.btnBugEl) {
      me.fireEvent('bugReport', me);
    }
  }
});
//# sourceMappingURL=pce.wcl.ux.wx-core-debug.js.map
